webpackJsonp([37],{

/***/ 1011:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth.js": 596,
	"./business.js": 572,
	"./calibrate.js": 597,
	"./calibrationHomepageMessage.js": 598,
	"./chat.js": 599,
	"./countries.js": 600,
	"./dashboard.js": 601,
	"./device.js": 602,
	"./files.js": 603,
	"./lookup.js": 604,
	"./maintenance.js": 605,
	"./openinghours.js": 606,
	"./report.js": 607,
	"./scanpro.js": 608,
	"./serviceElements.js": 609,
	"./servicerequest.js": 610,
	"./translation.js": 611,
	"./users.js": 612
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1015;

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/index.js": 618,
	"./auth/actions.js": 239,
	"./auth/getters.js": 240,
	"./auth/index.js": 619,
	"./auth/mutations.js": 241,
	"./auth/state.js": 242,
	"./auth/types.js": 146,
	"./business/actions.js": 243,
	"./business/getters.js": 244,
	"./business/index.js": 620,
	"./business/mutations.js": 245,
	"./business/state.js": 246,
	"./business/types.js": 147,
	"./calibrate/actions.js": 247,
	"./calibrate/getters.js": 248,
	"./calibrate/index.js": 621,
	"./calibrate/mutations.js": 249,
	"./calibrate/state.js": 250,
	"./calibrate/types.js": 251,
	"./chat/actions.js": 252,
	"./chat/getters.js": 253,
	"./chat/index.js": 622,
	"./chat/mutations.js": 254,
	"./chat/sendbird.js": 226,
	"./chat/state.js": 255,
	"./chat/types.js": 116,
	"./configuration/index.js": 623,
	"./configuration/types.js": 256,
	"./countries/index.js": 624,
	"./dashboard/actions.js": 257,
	"./dashboard/getters.js": 258,
	"./dashboard/index.js": 625,
	"./dashboard/mutations.js": 259,
	"./dashboard/state.js": 260,
	"./dashboard/types.js": 148,
	"./devices/actions.js": 261,
	"./devices/getters.js": 262,
	"./devices/index.js": 626,
	"./devices/mutations.js": 263,
	"./devices/state.js": 264,
	"./devices/types.js": 149,
	"./files/actions.js": 265,
	"./files/getters.js": 266,
	"./files/index.js": 627,
	"./files/mutations.js": 267,
	"./files/state.js": 268,
	"./files/types.js": 269,
	"./locales/index.js": 628,
	"./lookup/index.js": 629,
	"./maintenance/actions.js": 270,
	"./maintenance/getters.js": 271,
	"./maintenance/index.js": 630,
	"./maintenance/mutations.js": 272,
	"./maintenance/state.js": 273,
	"./maintenance/types.js": 150,
	"./make/actions.js": 274,
	"./make/getters.js": 275,
	"./make/index.js": 631,
	"./make/mutations.js": 276,
	"./make/state.js": 277,
	"./make/types.js": 278,
	"./message/actions.js": 279,
	"./message/getters.js": 280,
	"./message/index.js": 632,
	"./message/mutations.js": 281,
	"./message/state.js": 282,
	"./message/types.js": 283,
	"./notificationmessage/actions.js": 284,
	"./notificationmessage/getters.js": 285,
	"./notificationmessage/index.js": 633,
	"./notificationmessage/mutations.js": 286,
	"./notificationmessage/state.js": 287,
	"./notificationmessage/types.js": 151,
	"./openinghours/actions.js": 288,
	"./openinghours/getters.js": 289,
	"./openinghours/index.js": 634,
	"./openinghours/mutations.js": 290,
	"./openinghours/state.js": 291,
	"./openinghours/types.js": 152,
	"./report/actions.js": 292,
	"./report/getters.js": 293,
	"./report/index.js": 635,
	"./report/mutations.js": 294,
	"./report/state.js": 295,
	"./report/types.js": 296,
	"./scanpro/actions.js": 297,
	"./scanpro/getters.js": 298,
	"./scanpro/index.js": 636,
	"./scanpro/mutations.js": 299,
	"./scanpro/state.js": 300,
	"./scanpro/types.js": 153,
	"./serviceelements/index.js": 637,
	"./servicerequests/actions.js": 301,
	"./servicerequests/getters.js": 302,
	"./servicerequests/index.js": 638,
	"./servicerequests/mutations.js": 303,
	"./servicerequests/state.js": 304,
	"./servicerequests/types.js": 154,
	"./translation/actions.js": 305,
	"./translation/getters.js": 306,
	"./translation/index.js": 639,
	"./translation/mutations.js": 307,
	"./translation/state.js": 308,
	"./translation/types.js": 309,
	"./users/actions.js": 310,
	"./users/getters.js": 311,
	"./users/index.js": 640,
	"./users/mutations.js": 312,
	"./users/state.js": 313,
	"./users/types.js": 155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1016;

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 1018,
	"./es.json": 1019
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1017;

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports = {"btn.save":"Save","btn.cancel":"Cancel","btn.close":"Close","btn.delete":"Delete","btn.addholidayschedule":"Add Public Holiday","tab.standardopeninghours.title":"Standard Opening Hours","tab.publicholidayopeninghours.title":"Public Holiday Opening Hours","error.openingtimessetorempty":"Both opening and closing times must be set or left empty.","error.openingtimeearlier":"Opening time must be earlier than closing time.","error.datealreadyscheduled":"The selected date has already been scheduled.","msg.deleteconfirmation":"Are you sure you want to delete this scheduled holiday?","dialog.header.confirmdeletion":"Confirm Deletion","dialog.header.createnewschedule":"Create New Holiday Opening Hours","dialog.header.editHolidayschedule":"Edit Holiday Opening Hours","openingtimes.title.platform":"Platform","openingtimes.title.supportemail":"Support Email"}

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

module.exports = {"btn.save":"Save","btn.cancel":"Cancel","btn.close":"Close","btn.delete":"Delete","btn.addholidayschedule":"Add Public Holiday","tab.standardopeninghours.title":"Horario de apertura estándar","tab.publicholidayopeninghours.title":"Horario de apertura en días festivos","error.openingtimessetorempty":"Both opening and closing times must be set or left empty.","error.openingtimeearlier":"Opening time must be earlier than closing time.","error.datealreadyscheduled":"The selected date has already been scheduled.","msg.deleteconfirmation":"Are you sure you want to delete this scheduled holiday?","dialog.header.confirmdeletion":"Confirm Deletion","dialog.header.createnewschedule":"Create New Holiday Opening Hours","dialog.header.editHolidayschedule":"Edit Holiday Opening Hours","openingtimes.title.platform":"Platform","openingtimes.title.supportemail":"Support Email"}

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLOBAL_HANDLER", function() { return GLOBAL_HANDLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_MESSAGE_LIMIT", function() { return GET_MESSAGE_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_SENDBIRD", function() { return INIT_SENDBIRD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_COUNT", function() { return MAX_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MESSAGE", function() { return ADD_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_CHANNELS", function() { return RESET_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_USERS", function() { return RESET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_MESSAGES", function() { return RESET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TYPING", function() { return SET_TYPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE_USER", function() { return SET_PAGE_SIZE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM_USER", function() { return SET_SEARCH_TERM_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNEL_CHECKED", function() { return SET_CHANNEL_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_CHECKED", function() { return SET_USER_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGE_CHECKED", function() { return SET_MESSAGE_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNELS", function() { return SET_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNEL_MESSAGE_COUNT", function() { return SET_CHANNEL_MESSAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGES", function() { return SET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_REQUESTS", function() { return RESET_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUESTS", function() { return SET_REQUESTS; });
var GLOBAL_HANDLER = 'GLOBAL_HANDLER';
var GET_MESSAGE_LIMIT = 30;
var INIT_SENDBIRD = 'INIT_SENDBIRD';
var MAX_COUNT = '+9';
var ADD_MESSAGE = 'ADD_MESSAGE';
var RESET_CHANNELS = 'RESET_CHANNELS';
var RESET_USERS = 'RESET_USERS';
var RESET_MESSAGES = 'RESET_MESSAGES';
var SET_TYPING = 'SET_TYPING';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE_USER = 'SET_PAGE_SIZE_USER';
var SET_SEARCH_TERM_USER = 'SET_SEARCH_TERM_USER';
var SET_CHANNEL_CHECKED = 'SET_CHANNEL_CHECKED';
var SET_USER_CHECKED = 'SET_USER_CHECKED';
var SET_MESSAGE_CHECKED = 'SET_MESSAGE_CHECKED';
var SET_CHANNELS = 'SET_CHANNELS';
var SET_USERS = 'SET_USERS';
var SET_CHANNEL_MESSAGE_COUNT = 'SET_CHANNEL_MESSAGE_COUNT';
var SET_MESSAGES = 'SET_MESSAGES';
var RESET_REQUESTS = 'RESET_REQUESTS';
var SET_REQUESTS = 'SET_REQUESTS';

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var endpoints = {};
var files = __webpack_require__(1015);

files.keys().forEach(function (path) {
  var endpoint = files(path);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint).forEach(function (x) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint[x]).forEach(function (y) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(endpoints, y, { value: endpoint[x][y] });
    });
  });
});

/* harmony default export */ __webpack_exports__["a"] = (endpoints);

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_INFO", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PASSTHROUGH", function() { return SET_PASSTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ROLES", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOLUTION", function() { return SET_SOLUTION; });
var LOGOUT = 'LOGOUT';
var SET_USER = 'SET_USER';
var SET_USER_INFO = 'SET_USER_INFO';
var SET_PASSTHROUGH = 'SET_PASSTHROUGH';
var SET_ROLES = 'SET_ROLES';
var SET_SOLUTION = 'SET_SOLUTION';

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_BUSINESS_DATA", function() { return INIT_BUSINESS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TO_CART", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNT_MODAL", function() { return SET_DISCOUNT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESSES", function() { return SET_BUSINESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY_BILLING_ADDRESS_FROM_DEFAULT", function() { return COPY_BILLING_ADDRESS_FROM_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESS_SID", function() { return SET_BUSINESS_SID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NEW_USER_TO_LIST", function() { return ADD_NEW_USER_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NEW_USER_ID", function() { return SET_NEW_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MANUFACTURER", function() { return ADD_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_MANUFACTURER", function() { return REMOVE_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_MANUFACTURER_PERCENT", function() { return UPDATE_MANUFACTURER_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISTRIBUTORS", function() { return SET_DISTRIBUTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SALES_REPS", function() { return SET_SALES_REPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_INFO", function() { return SET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BILLING", function() { return SET_BILLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNTS", function() { return SET_DISCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNTS_PRODUCT_ADDS", function() { return SET_DISCOUNTS_PRODUCT_ADDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NOTES", function() { return SET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NOTE_TO_LIST", function() { return ADD_NOTE_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PERIOD_DATA", function() { return RESET_PERIOD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESS_STATUS", function() { return SET_BUSINESS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ROLES", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESSES_FOUND", function() { return SET_BUSINESSES_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SWAPSHOP", function() { return SET_SWAPSHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PROMOTION", function() { return SET_PROMOTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ALL_BUSINESSES", function() { return SET_ALL_BUSINESSES; });
var INIT_BUSINESS_DATA = 'INIT_BUSINESS_DATA';
var ADD_TO_CART = 'ADD_TO_CART';
var SET_DISCOUNT_MODAL = 'SET_DISCOUNT_MODAL';
var SET_LOADING = 'SET_LOADING';
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var SET_BUSINESSES = 'SET_BUSINESSES';
var COPY_BILLING_ADDRESS_FROM_DEFAULT = 'COPY_BILLING_ADDRESS_FROM_DEFAULT';
var SET_BUSINESS_SID = 'SET_BUSINESS_SID';
var ADD_NEW_USER_TO_LIST = 'ADD_NEW_USER_TO_LIST';
var SET_NEW_USER_ID = 'SET_NEW_USER_ID';
var ADD_MANUFACTURER = 'ADD_MANUFACTURER';
var REMOVE_MANUFACTURER = 'REMOVE_MANUFACTURER';
var UPDATE_MANUFACTURER_PERCENT = 'UPDATE_MANUFACTURER_PERCENT';
var SET_DISTRIBUTORS = 'SET_DISTRIBUTORS';
var SET_SALES_REPS = 'SET_SALES_REPS';
var ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var SET_LOCATION = 'SET_LOCATION';
var SET_INFO = 'SET_INFO';
var SET_USERS = 'SET_USERS';
var SET_BILLING = 'SET_BILLING';
var SET_DISCOUNTS = 'SET_DISCOUNTS';
var SET_DISCOUNTS_PRODUCT_ADDS = 'SET_DISCOUNTS_PRODUCT_ADDS';
var SET_NOTES = 'SET_NOTES';
var ADD_NOTE_TO_LIST = 'ADD_NOTE_TO_LIST';
var RESET_PERIOD_DATA = 'RESET_PERIOD_DATA';
var SET_BUSINESS_STATUS = 'SET_BUSINESS_STATUS';
var SET_ROLES = 'SET_ROLES';
var SET_BUSINESSES_FOUND = 'SET_BUSINESSES_FOUND';
var SET_SOURCE = 'SET_SOURCE';
var SET_SWAPSHOP = 'SET_SWAPSHOP';
var SET_PROMOTION = 'SET_PROMOTION';
var SET_ALL_BUSINESSES = 'SET_ALL_BUSINESSES';

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUESTS", function() { return SET_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCHEMA", function() { return SET_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_QUERY_TEMPLATES", function() { return SET_QUERY_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_TEMPLATE", function() { return SET_CURRENT_TEMPLATE; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_REQUESTS = 'SET_REQUESTS';
var SET_SCHEMA = 'SET_SCHEMA';
var SET_QUERY_TEMPLATES = 'SET_QUERY_TEMPLATES';
var SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE';

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICE", function() { return SET_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICES", function() { return SET_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICEFILE", function() { return SET_DEVICEFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICEFILES", function() { return SET_DEVICEFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_DEVICE", function() { return SET_CURRENT_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_DEVICES", function() { return CLEAR_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOOLS", function() { return SET_TOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOOL_MAKES", function() { return SET_TOOL_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FOUND_DEVICES", function() { return SET_FOUND_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FOUND_DEVICES", function() { return CLEAR_FOUND_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ASSOCIATED_DEVICES", function() { return SET_ASSOCIATED_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_DEVICE_DATA", function() { return INIT_DEVICE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SHIPMENT", function() { return SET_SHIPMENT; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_DEVICE = 'SET_DEVICE';
var SET_DEVICES = 'SET_DEVICES';
var SET_DEVICEFILE = 'SET_DEVICEFILE';
var SET_DEVICEFILES = 'SET_DEVICEFILES';
var SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE';
var CLEAR_DEVICES = 'CLEAR_DEVICES';
var SET_TOOLS = 'SET_TOOLS';
var SET_TOOL_MAKES = 'SET_TOOL_MAKES';
var SET_FOUND_DEVICES = ' SET_FOUND_DEVICES';
var CLEAR_FOUND_DEVICES = 'CLEAR_FOUND_DEVICES';
var SET_ASSOCIATED_DEVICES = 'SET_ASSOCIATED_DEVICES';
var INIT_DEVICE_DATA = 'INIT_DEVICE_DATA';
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var SET_SOURCE = 'SET_SOURCE';
var SET_LOCATION = 'SET_LOCATION';
var SET_SHIPMENT = 'SET_SHIPMENT';

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_WORKORDER", function() { return SET_WORKORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_WORKORDER", function() { return INIT_WORKORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TECHNICIANS", function() { return SET_TECHNICIANS; });
var SET_WORKORDER = 'SET_WORKORDER';
var INIT_WORKORDER = 'INIT_WORKORDER';
var SET_TECHNICIANS = 'SET_TECHNICIANS';

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CALIBRATION_HOMEPAGE_MESSAGE", function() { return SET_CALIBRATION_HOMEPAGE_MESSAGE; });
var SET_CALIBRATION_HOMEPAGE_MESSAGE = 'SET_CALIBRATION_HOMEPAGE_MESSAGE';

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_OUT_OF_HOURS_AUDIT_LOG", function() { return SET_OUT_OF_HOURS_AUDIT_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STANDARD_OPENING_HOURS", function() { return SET_STANDARD_OPENING_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HOLIDAY_OPENING_HOURS", function() { return SET_HOLIDAY_OPENING_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TENANT_DETAILS", function() { return SET_TENANT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECTED_TENANT", function() { return SET_SELECTED_TENANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_TENANT_SUPPORT_EMAIL", function() { return UPDATE_TENANT_SUPPORT_EMAIL; });
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_OUT_OF_HOURS_AUDIT_LOG = 'SET_OUT_OF_HOURS_AUDIT_LOG';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_STANDARD_OPENING_HOURS = 'SET_STANDARD_OPENING_HOURS';
var SET_HOLIDAY_OPENING_HOURS = 'SET_HOLIDAY_OPENING_HOURS';
var SET_TENANT_DETAILS = 'SET_TENANT_DETAILS';
var SET_SELECTED_TENANT = 'SET_SELECTED_TENANT';
var UPDATE_TENANT_SUPPORT_EMAIL = 'UPDATE_TENANT_SUPPORT_EMAIL';

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STEP", function() { return SET_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VISITED_STEP", function() { return SET_VISITED_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_VISITED_STEP", function() { return RESET_VISITED_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DECODED_VIN", function() { return SET_DECODED_VIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VEHICLE", function() { return SET_VEHICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SUBMODELS", function() { return RESET_SUBMODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATION", function() { return SET_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECTED_CHECKLIST_ITEMS", function() { return SET_SELECTED_CHECKLIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CORPORATE_ID", function() { return SET_CORPORATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CONFIGURATION", function() { return SET_SCANPRO_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CHECKLIST", function() { return SET_SCANPRO_CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CRITERIA", function() { return SET_SCANPRO_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CRITERIA_CHANGED", function() { return SET_CRITERIA_CHANGED; });
var SET_STEP = 'SET_STEP';
var SET_VISITED_STEP = 'SET_VISITED_STEP';
var RESET_VISITED_STEP = 'RESET_VISITED_STEP';
var SET_DECODED_VIN = 'SET_DECODED_VIN';
var SET_VEHICLE = 'SET_VEHICLE';
var RESET_SUBMODELS = 'RESET_SUBMODELS';
var SET_RECOMMENDATION = 'SET_RECOMMENDATION';
var SET_SELECTED_CHECKLIST_ITEMS = 'SET_SELECTED_CHECKLIST_ITEMS';
var SET_CORPORATE_ID = 'SET_CORPORATE_ID';
var SET_SCANPRO_CONFIGURATION = 'SET_SCANPRO_CONFIGURATION';
var SET_SCANPRO_CHECKLIST = 'SET_SCANPRO_CHECKLIST';
var SET_SCANPRO_CRITERIA = 'SET_SCANPRO_CRITERIA';
var SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED';

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST", function() { return SET_SERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUESTS", function() { return SET_SERVICE_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST_HISTORY", function() { return SET_SERVICE_REQUEST_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST_ISSUES", function() { return SET_SERVICE_REQUEST_ISSUES; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_SERVICE_REQUEST = 'SET_SERVICE_REQUEST';
var SET_SERVICE_REQUESTS = 'SET_SERVICE_REQUESTS';
var SET_SERVICE_REQUEST_HISTORY = 'SET_SERVICE_REQUEST_HISTORY';
var SET_SERVICE_REQUEST_ISSUES = 'SET_SERVICE_REQUEST_ISSUES';

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_USER", function() { return SET_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_USER", function() { return INIT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HIGHLIGHT", function() { return SET_HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HIGHLIGHT_PASSWORD", function() { return SET_HIGHLIGHT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_ROLE", function() { return SET_USER_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_USER = 'SET_USER';
var SET_USERS = 'SET_USERS';
var SET_CURRENT_USER = 'SET_CURRENT_USER';
var INIT_USER = 'INIT_USER';
var SET_HIGHLIGHT = 'SET_HIGHLIGHT';
var SET_HIGHLIGHT_PASSWORD = 'SET_HIGHLIGHT_PASSWORD';
var SET_USER_ROLE = 'SET_USER_ROLE';
var SET_SOURCE = 'SET_SOURCE';

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






var http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create();
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  auth: function auth(data, callback, error) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(window.config.authService, data).then(callback).catch(error);
  },
  get: function get(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + window.config.apiUrl + endpoint, data);
  },
  post: function post(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('' + window.config.apiUrl + endpoint, data, config);
  }
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, { $http: {
    get: function get() {
      return http;
    }
  } });

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guard_route__ = __webpack_require__(616);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__guard_route__["a" /* default */])(to, from, next);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sendbird__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sendbird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sendbird__);




/* harmony default export */ __webpack_exports__["default"] = ({
  strict: false,
  namespaced: true,
  sendbird: null,
  channel: null,
  channelSet: null,
  channelListQuery: null,
  memberCount: 0,
  memberList: [],

  initSendBird: function initSendBird(callback) {
    this.sendbird = new __WEBPACK_IMPORTED_MODULE_2_sendbird___default.a({
      appId: window.config.sendbirdToken
    });
  },
  connectChat: function connectChat(register, callback) {
    var _this = this;

    var self = this;
    if (this.sendbird === undefined || this.sendbird === null) {
      this.initSendBird();
    }
    this.sendbird.connect(register.userId.trim(), function (user, error) {
      if (error) {
        console.error(error);
        return;
      }
      _this.sendbird.updateCurrentUserInfo(register.nickname.trim(), '', function (response, error) {
        if (error) {
          console.error(error);
        } else {
          callback(response);
        }
      });
      var channelHandler = new _this.sendbird.ChannelHandler();
      channelHandler.onMessageReceived = function (channel, message) {
        console.log('Message Received', message);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('chat/addMessageToList', message);
        if ('Notification' in window) {
          document.getElementById('notifierSound').play();
        }
      };
      channelHandler.onMessageUpdated = function (channel, message) {
        console.log('Message Updated', message);
      };
      channelHandler.onMessageDeleted = function (channel, messageId) {
        console.log('Message Deleted', messageId);
      };
      channelHandler.onChannelChanged = function (channel) {
        console.log('Channel Changed', channel);
        self.getTotalUnreadCount(function (counts) {});
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('serviceRequests/updateRequestUnread', { id: channel.name, count: channel.unreadMessageCount });
      };
      channelHandler.onTypingStatusUpdated = function (channel) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('chat/setTyping', channel);
      };
      channelHandler.onReadReceiptUpdated = function (channel) {
        console.log('Message Read');
      };
      channelHandler.onUserLeft = function (channel, user) {
        console.log('User Left', user);
      };
      channelHandler.onUserJoined = function (channel, user) {
        console.log('User Joined', user);
      };
      _this.sendbird.addChannelHandler([__WEBPACK_IMPORTED_MODULE_0__types__["GLOBAL_HANDLER"]], channelHandler);
    });
  },

  setChannel: function setChannel(channel) {
    this.channel = channel;
  },
  getChannelInfo: function getChannelInfo(channelUrl, callback) {
    this.sendbird.GroupChannel.getChannel(channelUrl, function (channel, error) {
      if (error) {
        console.error(error);
        callback(null, error);
      }
      callback(channel, null);
    });
  },
  getChannelUnreadCount: function getChannelUnreadCount(channel) {
    return channel.unreadMessageCount;
  },
  getMessageList: function getMessageList(channelSet, callback) {
    if (!channelSet.query) {
      channelSet.query = channelSet.channel.createPreviousMessageListQuery();
    }
    if (channelSet.query.hasMore && !channelSet.query.isLoading) {
      channelSet.query.load(__WEBPACK_IMPORTED_MODULE_0__types__["GET_MESSAGE_LIMIT"], false, function (messageList, error) {
        if (error) {
          console.error(error);
        }
        callback(messageList);
      });
    }
  },

  insertMessageInList: function insertMessageInList(target, index, item) {
    return target.splice(index, 0, item);
  },
  getTotalUnreadCount: function getTotalUnreadCount(callback) {
    this.sendbird.getTotalUnreadMessageCount(function (unreadCount) {
      if (callback) {
        callback(unreadCount);
      }
    });
  },

  getUserList: function getUserList(search, action) {
    var self = this;
    var processUsers = function processUsers(data) {
      var query = [];
      if (data !== undefined && data !== null) {
        data.forEach(function (item) {
          query.push({
            userId: item.email,
            nickname: item.firstName + ' ' + item.lastName,
            profileUrl: item.profileUrl !== null ? item.profileUrl : '',
            isOnline: item.isOnline
          });
        });
      }
      return query;
    };
    if (!self.userListQuery) {
      var xmlHttp = new XMLHttpRequest();
      var url = this.api.url + 'chat/Users';
      if (search !== undefined && search !== null) {
        url += '?token=&pagesize=5&search=' + search;
      } else {
        url += '?token=&pagesize=50';
      }
      xmlHttp.open('GET', url, true);
      xmlHttp.setRequestHeader('Authorization', this.api.token);
      xmlHttp.onload = function () {
        if (xmlHttp.readyState === 4) {
          if (xmlHttp.status === 200) {
            var data = JSON.parse(xmlHttp.responseText);
            if (data !== undefined && data !== null) {
              self.userListQuery = processUsers(data);
              self.userListQuery.isLoading = false;
              self.userListQuery.limit = 50;
              self.userListQuery.hasNext = false;
              self.userListQuery.next = null;
              action(self.userListQuery);
            }
          } else {
            console.error(xmlHttp.statusText);
          }
        }
      };
      xmlHttp.onerror = function (e) {
        console.error(xmlHttp.statusText);
      };
      xmlHttp.send(null);
    }
  },
  xssEscape: function xssEscape(target) {
    if (typeof target === 'string') {
      return target.split('&').join('&amp').split('#').join('&#35').split('<').join('&lt').split('>').join('&gt').split('"').join('&quot').split("'").join('&apos').split('+').join('&#43').split('-').join('&#45').split('(').join('&#40').split(')').join('&#41').split('%').join('&#37');
    } else {
      return target;
    }
  },
  getMessageTime: function getMessageTime(message) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var _getDay = function _getDay(val) {
      var day = parseInt(val);
      if (day === 1) {
        return day + 'st';
      } else if (day === 2) {
        return day + 'en';
      } else if (day === 3) {
        return day + 'rd';
      } else {
        return day + 'th';
      }
    };
    var _checkTime = function _checkTime(val) {
      return +val < 10 ? '0' + val : val;
    };
    if (message) {
      var LAST_MESSAGE_TODAY = 'today';
      var LAST_MESSAGE_YESTERDAY = 'yesterday';
      var _nowDate = new Date();
      var _date = new Date(message.createdAt);
      var _time = _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes());
      if (_nowDate.getDate() - _date.getDate() === 1) {
        return LAST_MESSAGE_YESTERDAY + ' at ' + _time;
      } else if (_nowDate.getFullYear() === _date.getFullYear() && _nowDate.getMonth() === _date.getMonth() && _nowDate.getDate() === _date.getDate()) {
        return LAST_MESSAGE_TODAY + ' at ' + _time;
      } else {
        return months[_date.getMonth()] + ' ' + _getDay(_date.getDate()) + ' at ' + _time;
      }
    }
    return '';
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(146);





function collectChildValidation($this, validations) {
  $this.$children.forEach(function (vm) {
    validations.push(vm.$validator.validateAll());
    if (vm.$children.length) {
      collectChildValidation(vm, validations);
    }
  });
}
/* harmony default export */ __webpack_exports__["default"] = ({
  veeValidateAll: function veeValidateAll(_ref, $this) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var validations = [$this.$validator.validateAll()];
      collectChildValidation($this, validations);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(validations).then(function (r) {
        return resolve(r.every(function (i) {
          return i === true;
        }));
      }).catch(reject);
    });
  },
  setPassthrough: function setPassthrough(_ref2, passthrough) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_PASSTHROUGH"], passthrough);
  },
  checkAuth: function checkAuth(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (!localStorage.getItem('token')) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["LOGOUT"]);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], localStorage.getItem('token'));
      if (!localStorage.getItem('userProfile')) {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUserInfo(state.loggedUser.username).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_INFO"], response.data);
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_ROLES"], JSON.parse(localStorage.getItem('userProfile')));
        });
      }
    }
  },
  authUser: function authUser(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authUser(data, function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], response.data);

        resolve(response);
      }, function (error) {
        reject(error);
      });
    }).then(function () {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUserInfo(state.loggedUser.username).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_INFO"], response.data);
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_ROLES"], JSON.parse(localStorage.getItem('userProfile')));
        console.log('Route Home 2');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
      });
    });
  },
  setSolution: function setSolution(_ref5, solution) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_SOLUTION"], solution);
  },
  logout: function logout(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["LOGOUT"]);
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var PAGE_PERMISSIONS = {
  '/partner': ['SuperAdmin', 'Admin'],
  '/partner/create': ['SuperAdmin', 'Admin'],
  '/partner/update': ['SuperAdmin', 'Admin'],
  '/business': ['SuperAdmin', 'Admin'],
  '/business/create': ['SuperAdmin', 'Admin'],
  '/business/update': ['SuperAdmin', 'Admin'],
  '/dashboard/requests': ['SuperAdmin', 'Admin'],
  '/dashboard/statistics': ['SuperAdmin', 'Admin'],
  '/dashboard/devicestatistics': ['SuperAdmin', 'Admin'],
  '/dashboard/activationcardstatistics': ['SuperAdmin', 'Admin'],
  '/dashboard/businessaccountsinfo': ['SuperAdmin', 'Admin'],
  '/dashboard/deviceshipments': ['SuperAdmin', 'Admin'],
  '/admin/defaults': ['SuperAdmin', 'Admin'],
  '/admin/salesreps': ['SuperAdmin', 'Admin'],
  '/admin/translation': ['SuperAdmin', 'Admin'],
  '/admin/service-element-translation': ['SuperAdmin', 'Admin'],
  '/admin/message': ['SuperAdmin', 'Admin'],
  '/admin/devices': ['SuperAdmin', 'Admin'],
  '/admin/device-files': ['SuperAdmin', 'Admin'],
  '/admin/device-file-detail': ['SuperAdmin', 'Admin'],
  '/admin/report': ['SuperAdmin', 'Admin'],
  '/admin/maintenance': ['SuperAdmin', 'Admin'],
  '/admin/calibrate': ['SuperAdmin', 'Admin'],
  '/admin/mobile': ['SuperAdmin', 'Admin'],
  '/admin/files': ['SuperAdmin', 'Admin'],
  '/admin/chat': ['SuperAdmin', 'Admin'],
  '/admin/scanpro': ['SuperAdmin', 'Admin'],
  '/users': ['SuperAdmin', 'Admin'],
  '/users/create': ['SuperAdmin', 'Admin'],
  '/users/update': ['SuperAdmin', 'Admin'],
  '/admin/makes': ['SuperAdmin', 'Admin'],
  '/admin/calibration-homepage-message': ['SuperAdmin', 'Admin'],
  '/admin/openinghours': ['SuperAdmin', 'Admin'],
  '/admin/openinghours/opening-hours': ['SuperAdmin', 'Admin'],
  '/admin/openinghours/auditLog': ['SuperAdmin', 'Admin'],
  '/admin/rag': ['SuperAdmin', 'Admin'],
  '/admin/rag/auditLog': ['SuperAdmin', 'Admin'],
  '/admin/rag/maintenance': ['SuperAdmin', 'Admin'],
  '/admin/rag/Translations (Service Elements)': ['SuperAdmin', 'Admin'],
  '/admin/device-detail': ['SuperAdmin', 'Admin']
};
/* harmony default export */ __webpack_exports__["default"] = ({
  passthrough: function passthrough(state) {
    return state.passthrough;
  },
  token: function token(state) {
    return state.token;
  },
  loggedUser: function loggedUser(state) {
    return state.loggedUser;
  },
  userProfile: function userProfile(state) {
    return state.userProfile;
  },
  primaryRole: function primaryRole(state) {
    return state.primaryRole;
  },
  roles: function roles(state) {
    return state.roles;
  },
  solutions: function solutions(state) {
    return state.solutions;
  },
  solution: function solution(state) {
    return state.solution;
  },
  channelType: function channelType(state) {
    return state.channelType;
  },
  isAllowed: function isAllowed(state) {
    return function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var pageArray = page.split('/');
      var checkPage = '';
      var cnt = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pageArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item !== '' && cnt < 2) {
            if (isNaN(item)) {
              checkPage += '/' + item;
            }
            cnt++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!PAGE_PERMISSIONS[checkPage]) {
        console.log('Page does not exist', checkPage);
        return false;
      }
      if (state.roles && state.roles.length) {
        console.log('Checking Roles');
        return state.roles.some(function (r) {
          return PAGE_PERMISSIONS[checkPage].includes(r);
        });
      }
      return false;
    };
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);



var _types$SET_PASSTHROUG;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_PASSTHROUG = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PASSTHROUGH"], function (state, passthrough) {
  state.passthrough = passthrough;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER"], function (state, token) {
  state.loggedUser.username = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token).prn;
  state.loggedUser.role = 'user';
  localStorage.setItem('token', token);
  state.token = token;
  if (localStorage.getItem('userProfile') !== undefined && localStorage.getItem('userProfile') !== null) {
    state.userProfile = JSON.parse(localStorage.getItem('userProfile'));
    state.loggedUser.role = state.userProfile.Role;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER_INFO"], function (state, data) {
  if (data.length > 0) {
    state.userProfile = data[0];
    localStorage.setItem('userProfile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data[0]));
    state.loggedUser.role = state.userProfile.Role;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["LOGOUT"], function (state) {
  state.token = '';
  state.role = '';
  state.roles = null;
  state.userProfile = null;
  state.loggedUser = { username: null, role: null };
  localStorage.removeItem('token');
  localStorage.removeItem('roles');
  localStorage.removeItem('role');
  localStorage.removeItem('userProfile');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ROLES"], function (state, profile) {
  state.primaryRole = '';
  if (profile && profile.Roles && profile.Roles.length) {
    var roles = profile.Roles.map(function (r) {
      return r.Name;
    });
    state.roles = roles;
    localStorage.setItem('roles', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(roles));
    if (roles.length > 0) {
      state.primaryRole = roles[0];
    }
    localStorage.setItem('role', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.primaryRole));
    console.log('Saving Roles', { roles: state.roles, role: state.primaryRole });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SOLUTION"], function (state, solution) {
  state.solution = solution;
  state.solutions.forEach(function (element) {
    if (parseInt(element.value) === parseInt(solution)) {
      localStorage.setItem('solution', solution);
      state.channelType = element.type;
      localStorage.setItem('channelType', element.type);
    }
  });
}), _types$SET_PASSTHROUG);

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    passthrough: '',
    token: localStorage.getItem('token'),
    loggedUser: {
      username: null,
      role: null
    },
    userProfile: JSON.parse(localStorage.getItem('userProfile')),
    primaryRole: JSON.parse(localStorage.getItem('role')),
    roles: JSON.parse(localStorage.getItem('roles')),
    solutions: [{
      id: 1,
      name: 'UK/Europe',
      value: 1,
      type: 'ServiceRequest'
    }, {
      id: 2,
      name: 'Glass US/Canada',
      value: 2,
      type: 'ServiceRequestGlass'
    }, {
      id: 3,
      name: 'Calibration US/Canada',
      value: 4,
      type: 'ServiceRequestCalibration'
    }, {
      id: 4,
      name: 'ProTech',
      value: 5,
      type: 'ServiceRequestProTech'
    }],
    channelType: localStorage.getItem('channelType') || 'ServiceRequest',
    solution: localStorage.getItem('solution') || 1
  };
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(147);







/* harmony default export */ __webpack_exports__["default"] = ({
  initBusinessModel: function initBusinessModel(_ref, data) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["INIT_BUSINESS_DATA"], data);
  },
  setActiveTab: function setActiveTab(_ref2, tab) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ACTIVE_TAB"], tab);
  },
  showModal: function showModal(_ref3, modal) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNT_MODAL"], modal);
  },
  setSource: function setSource(_ref4, source) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_SOURCE"], source);
  },
  addNewUserToList: function addNewUserToList(_ref5, defaultTitleId) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    if (defaultTitleId) {
      commit('admin/ADD_SALES_REPRESENTATIVE', defaultTitleId, { root: true });
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NEW_USER_TO_LIST"], defaultTitleId);
    }
  },
  copyBillingAddressFromDefault: function copyBillingAddressFromDefault(_ref6, isBillingSameAsDefault) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var address;
    if (isBillingSameAsDefault) {
      address = state.business.primaryAddress;
    } else {
      address = {
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        language: 1
      };
    }

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], address);
  },
  getBusinesses: function getBusinesses(_ref7, data) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinesses(data).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESSES"], response.data);
    });
  },
  upsertBusiness: function upsertBusiness(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusiness', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusiness(state.business).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESS_SID"], response.data);

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusiness', show: false });
      });
    });
  },
  swapShop: function swapShop(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'swapShop', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].swapShop({ oldShopId: state.business.id, newShopId: state.business.shopId }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessLocation(state.business.sid).then(function (response) {
          if (response.status === 200) {
            commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOCATION"], response.data);
          }
          resolve(response);
        });
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data.errorMessage);
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'swapShop', show: false });
      });
    });
  },
  setBusinessStatus: function setBusinessStatus(_ref10, data) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].setBusinessStatus(data).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESS_STATUS"], data);
        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  upsertBusinessUser: function upsertBusinessUser(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: true });

    var promises = state.business.users.map(function (user) {
      user.sid = state.business.sid;

      if (user.receivesReportsOnly === undefined || user.receivesReportsOnly === null) {
        user.receivesReportsOnly = false;
      }
      if (user.receivesChatReports === undefined || user.receivesChatReports === null) {
        user.receivesChatReports = false;
      }
      console.log('Updating User', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user));

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessUser(user).then(function (response) {
          resolve({ user: user, data: response.data });
        }).catch(function (error) {
          resolve({ user: user, data: new Error(error.response.data) });
        });
      });
    });

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function (responses) {
      var errors = [];
      responses.forEach(function (response) {
        if (response.data instanceof Error) {
          errors.push({ user: response.user, error: response.data });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_NEW_USER_ID"], { user: response.user, newId: response.data.id });
        }
      });
      return errors;
    }).then(function (errors) {
      if (errors.length > 0) {
        var msg = 'Error(s) on the following user(s): \n';
        errors.forEach(function (x) {
          msg += x.user.firstName + ' ' + x.user.lastName + ': ' + x.error.message + ' \n';
        });

        alert(msg);
      } else {
        alert('Saved successfully!');
      }
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: false });
    });
  },
  removeUser: function removeUser(_ref12, user) {
    var commit = _ref12.commit,
        state = _ref12.state;

    state.business.users.splice(state.business.users.indexOf(user), 1);
  },
  resetUserPassword: function resetUserPassword(_ref13, user) {
    var commit = _ref13.commit,
        state = _ref13.state;

    if (user.password === null) {
      alert('Password must be provided.');
      return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = {
        password: user.password,
        resetLockout: user.isLockout,
        id: user.userId
      };
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].resetUserPassword(data).then(function (response) {
        alert('User password has been reset successfully!');
        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  upsertBusinessNote: function upsertBusinessNote(_ref14, _ref15) {
    var commit = _ref14.commit,
        state = _ref14.state;
    var note = _ref15.note,
        hasFiles = _ref15.hasFiles;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: true });

    var body = {
      sid: state.business.sid,
      noteId: null,
      text: note.get('note')
    };

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessNote(body).then(function (response) {
        if (response.status === 200) {
          var dateCreated = new Date().toISOString();

          var newNote = {
            id: parseInt(response.data),
            text: note.get('note'),
            files: null,
            dateCreated: dateCreated
          };
        }
        resolve(newNote);
      }).catch(function (error) {
        alert(error);
        reject(error);
      });
    }).then(function (newNote) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (hasFiles) {
          note.append('commentId', newNote.id);

          __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessDocument(note).then(function (response) {
            commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NOTE_TO_LIST"], newNote);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.business.notes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _note = _step.value;

                if (_note.id === newNote.id) {
                  _note.files = response.data;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
            resolve();
          }).catch(function (error) {
            alert('Something went wrong with the files.');
            reject(error);
          });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NOTE_TO_LIST"], newNote);
          resolve();
        }
      });
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
    });
  },
  upsertBusinessInfo: function upsertBusinessInfo(_ref16) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: true });

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessInfo(state.business).then(function (response) {
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: false });
      });
    });
  },
  upsertBusinessPromotion: function upsertBusinessPromotion(_ref17) {
    var commit = _ref17.commit,
        state = _ref17.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessPromotion', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var body = state.business.promotion;
      body.sid = state.business.sid;
      body.id = state.business.id;
      body.startDate = new Date(state.business.promotion.startDate);
      body.endDate = new Date(state.business.promotion.endDate);

      console.log(body.sid);
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessPromotion(body).then(function (response) {
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessPromotion', show: false });
      });
    });
  },
  upsertBusinessBilling: function upsertBusinessBilling(_ref18) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: true });

    var body = state.business.billing;
    body.sid = state.business.sid;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessBilling(body).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BILLING"], state.business.billing);

        console.log('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(_ref19, _ref20) {
    var commit = _ref19.commit,
        state = _ref19.state;
    var mappingTypeId = _ref20.mappingTypeId,
        otherDescriptorId = _ref20.otherDescriptorId;

    var body = {
      mappingTypeId: mappingTypeId,
      otherDescriptorId: otherDescriptorId,
      products: state.business.discounts,
      sid: state.business.sid
    };

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessDiscount(body).then(function (response) {
        response.data.forEach(function (x, i) {
          if (!x.success) {
            response.data[i] = state.business.discounts.filter(function (discount) {
              return discount.id === x.id;
            })[0];
            response.data[i].success = false;
          }
        });

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong!');
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  upsertBusinessProductAddDiscount: function upsertBusinessProductAddDiscount(_ref21) {
    var commit = _ref21.commit,
        state = _ref21.state;

    var body = {
      productAdds: [],
      id: parseInt(state.business.id)
    };
    state.business.discountsProductAdds.forEach(function (element) {
      if (element.isChanged) {
        body.productAdds.push({
          id: parseInt(element.id),
          isTriggerDTC: element.isTriggerDTC,
          isActive: element.isActive === null ? 1 : element.isActive,
          discount: {
            typeId: parseInt(element.discount.typeId),
            amount: parseFloat(element.discount.amount)
          }
        });
      }
    });
    console.log('Saving Product Add Discounts', body);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertDiscountProductAdd(body).then(function (response) {
        response.data.forEach(function (x, i) {
          if (!x.success) {
            response.data[i] = state.business.discountsProductAdds.filter(function (discount) {
              return discount.id === x.id;
            })[0];
            response.data[i].success = false;
          }
        });

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong!');
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  modifyManufacturer: function modifyManufacturer(_ref22, _ref23) {
    var commit = _ref22.commit;
    var manufacturer = _ref23.manufacturer,
        event = _ref23.event;

    var obj = { id: manufacturer.id, percent: document.getElementById('manufacturer_percent_' + manufacturer.name).value };
    if (event.target.checked) {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_MANUFACTURER"], obj);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["REMOVE_MANUFACTURER"], obj);
    }
  },
  updateManufacturerPercent: function updateManufacturerPercent(_ref24, _ref25) {
    var commit = _ref24.commit;
    var id = _ref25.id,
        event = _ref25.event;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["UPDATE_MANUFACTURER_PERCENT"], { id: id, percent: event.target.value });
  },
  getDistributors: function getDistributors(_ref26) {
    var commit = _ref26.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getDistributors().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISTRIBUTORS"], response.data);
      }
    });
  },
  getSalesReps: function getSalesReps(_ref27) {
    var commit = _ref27.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getSalesReps().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_SALES_REPS"], response.data);
      }
    });
  },
  addDiscountByVolumeToProduct: function addDiscountByVolumeToProduct(_ref28, productIndex) {
    var commit = _ref28.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], productIndex);
  },
  removeDiscountByVolumeToProduct: function removeDiscountByVolumeToProduct(_ref29, _ref30) {
    var commit = _ref29.commit;
    var discountIndex = _ref30.discountIndex,
        productIndex = _ref30.productIndex;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], { discountIndex: discountIndex, productIndex: productIndex });
  },
  getBusinessLocation: function getBusinessLocation(_ref31, sid) {
    var commit = _ref31.commit,
        state = _ref31.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessLocation(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOCATION"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessInfo: function getBusinessInfo(_ref32, sid) {
    var commit = _ref32.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessInfo(sid).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_INFO"], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessPromotion: function getBusinessPromotion(_ref33, sid) {
    var commit = _ref33.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessPromotion(sid).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_PROMOTION"], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessUsers: function getBusinessUsers(_ref34, sid) {
    var commit = _ref34.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessUsers(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_USERS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessBilling: function getBusinessBilling(_ref35, sid) {
    var commit = _ref35.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessBilling(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BILLING"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref36, _ref37) {
    var commit = _ref36.commit,
        state = _ref36.state;
    var type = _ref37.type,
        other = _ref37.other;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessDiscounts({ sid: state.business.sid, type: type, other: other }).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNTS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessProductAddDiscounts: function getBusinessProductAddDiscounts(_ref38) {
    var commit = _ref38.commit,
        state = _ref38.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessDiscountsProductAdds({ sid: state.business.sid }).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNTS_PRODUCT_ADDS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessNotes: function getBusinessNotes(_ref39, sid) {
    var commit = _ref39.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessNotes(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_NOTES"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getDownloadToken: function getDownloadToken(_ref40, fileId) {
    var commit = _ref40.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getDownloadToken(fileId).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  resetPeriodData: function resetPeriodData(_ref41) {
    var commit = _ref41.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["RESET_PERIOD_DATA"]);
  },
  lookupBusiness: function lookupBusiness(_ref42, search) {
    var commit = _ref42.commit,
        dispatch = _ref42.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].lookupBusiness(search).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getRoles: function getRoles(_ref43, type) {
    var commit = _ref43.commit,
        dispatch = _ref43.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (type === undefined || type === null) {
        type = '1';
      }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getRoles(type).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ROLES"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  searchBusinesses: function searchBusinesses(_ref44, search) {
    var commit = _ref44.commit,
        dispatch = _ref44.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].searchBusinesses(search).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESSES_FOUND"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getAllBusinessesForDropdowns: function getAllBusinessesForDropdowns(_ref45) {
    var commit = _ref45.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinesses({
        params: {
          search: '',
          orderBy: 'name',
          sortBy: 'asc',
          status: '',
          pageSize: 10000,
          offset: 0
        }
      }).then(function (response) {
        console.log('getAllBusinessesForDropdowns response:', response.data);
        console.log('Response data structure:', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data || {}));
        if (response.data && response.data.results) {
          console.log('Sample business item:', response.data.results[0]);
          console.log('Total businesses loaded:', response.data.results.length);
        }

        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ALL_BUSINESSES"], response.data);
        resolve(response.data);
      }).catch(function (error) {
        console.error('Failed to load all businesses for dropdowns:', error);
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: function searchKey(state) {
    return state.searchKey;
  },
  activeTab: function activeTab(state) {
    return state.activeTab;
  },
  tabs: function tabs(state) {
    return state.tabs;
  },
  activeMappingType: function activeMappingType(state) {
    return state.activeMappingType;
  },

  business: function business(state) {
    return state.business;
  },

  loading: function loading(state) {
    return state.loading;
  },
  businesses: function businesses(state) {
    return state.businesses;
  },
  distributors: function distributors(state) {
    return state.distributors;
  },
  salesReps: function salesReps(state) {
    return state.salesReps;
  },
  vehicleManufacturers: function vehicleManufacturers(state) {
    return state.vehicleManufacturers;
  },
  insuranceCompanies: function insuranceCompanies(state) {
    return state.insuranceCompanies;
  },
  products: function products(state) {
    return state.products;
  },
  roles: function roles(state) {
    return state.roles;
  },
  businessesFound: function businessesFound(state) {
    return state.businessesFound;
  },
  source: function source(state) {
    return state.source;
  },
  allBusinesses: function allBusinesses(state) {
    return state.allBusinesses || { results: [] };
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(147);



var _types$INIT_BUSINESS_;



/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_BUSINESS_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_BUSINESS_DATA"], function (state, data) {
  state.business = {
    id: 0,
    shopId: '',
    sid: null,
    statusId: null,
    name: null,
    timezone: null,
    phone: null,
    phoneCC: null,
    billSameAsPrimary: false,
    dispatchPriorityId: null,
    distributorId: null,
    salesRepId: null,
    referralSourceId: null,
    isMobileClient: false,
    isEnterpriseClient: false,
    isAstechClient: false,
    isHunterClient: false,
    isSafeliteClient: false,
    isCorporateAccount: false,
    isCapLinkMember: false,
    isSolera: false,
    soleraSiteIdReference: null,
    isOnyxClient: false,
    onyxClientReference: null,
    capricornNumber: '',
    accountId: null,
    annualRevenueId: null,
    monthlyRoId: null,
    locationCountId: null,
    reportingGroupId: null,
    parentId: null,
    grandparentId: null,
    manufacturers: [],
    oemCertifications: [],
    insuranceDepartments: [],
    services: [],
    primaryAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null,
      country: null,
      language: 1
    },
    billingAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null,
      country: null,
      language: 1
    },
    users: [],
    billing: {
      isDemo: false,
      isRecurring: false,
      periodId: null,
      periodAmount: null,
      currencyId: null,
      isCurrencyIdSavedInDatabase: false,
      oemChargeableProducts: []
    },
    promotion: {
      startDate: new Date(),
      endDate: new Date(),
      startProductId: 0,
      endProductId: 0,
      promotionType: 0,
      numberOfScans: 0
    },
    discounts: [],
    notes: []
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNT_MODAL"], function (state, modal) {
  state.activeMappingType = modal;
  if (modal === null) {
    state.business.discounts = [];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOADING"], function (state, _ref) {
  var button = _ref.button,
      show = _ref.show;

  state.loading[button] = show;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ACTIVE_TAB"], function (state, tab) {
  state.activeTab = tab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESSES"], function (state, businesses) {
  state.businesses = businesses;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESS_STATUS"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.businesses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var business = _step.value;

      if (business.id === data.id) {
        business.statusId = data.status;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], function (state, address) {
  state.business.billingAddress = address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESS_SID"], function (state, sid) {
  state.business.sid = sid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NEW_USER_TO_LIST"], function (state) {
  state.business.users.push({
    id: 0,
    firstName: null,
    lastName: null,
    hasLogin: false,
    username: null,
    email: null,
    password: null,
    requiresPasswordOnSubmit: false,
    isPrimary: false,
    isEnabled: false,
    isLockout: false,
    isDeleted: false,
    isMahle: false,
    receivesInvoices: false,
    receivesReports: false,
    receivesReportsOnly: false,
    receivesChatReports: false,
    isAstechUser: false,
    titleId: null,
    phone: null,
    phoneCC: null
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NEW_USER_ID"], function (state, _ref2) {
  var user = _ref2.user,
      newId = _ref2.newId;

  var index = state.business.users.findIndex(function (u) {
    return u === user;
  });
  if (state.business.users[index].id === 0) {
    state.business.users[index].id = newId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MANUFACTURER"], function (state, manufacturer) {
  state.business.manufacturers.push(manufacturer);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_MANUFACTURER"], function (state, manufacturer) {
  var index = state.business.manufacturers.findIndex(function (x) {
    return x.id === manufacturer.id;
  });
  state.business.manufacturers.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["UPDATE_MANUFACTURER_PERCENT"], function (state, _ref3) {
  var id = _ref3.id,
      percent = _ref3.percent;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.business.manufacturers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var manufacturer = _step2.value;

      if (manufacturer.id === id) {
        manufacturer.percent = percent;
        break;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISTRIBUTORS"], function (state, distributors) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SALES_REPS"], function (state, salesReps) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, productIndex) {
  state.business.discounts[productIndex].discountsByVolume.push({
    id: null,
    typeId: null,
    amount: null,
    volumeBreak: null,
    isActive: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, _ref4) {
  var discountIndex = _ref4.discountIndex,
      productIndex = _ref4.productIndex;

  state.business.discounts[productIndex].discountsByVolume.splice(discountIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOCATION"], function (state, location) {
  state.business.id = location.id;
  state.business.sid = location.sid;
  state.business.shopId = location.shopId;
  state.business.name = location.name;
  state.business.timezone = location.timezone;
  state.business.phone = location.phone;
  state.business.phoneCC = location.phoneCC;
  state.business.language = location.language;
  state.business.billSameAsPrimary = location.billSameAsPrimary;
  state.business.primaryAddress = location.primaryAddress;

  state.business.billingAddress = state.business.billSameAsPrimary ? location.primaryAddress : location.billingAddress;
  state.business.billingAddress.state = state.business.billSameAsPrimary ? location.primaryAddress.state : location.billingAddress.state;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_INFO"], function (state, info) {
  if (info) {
    state.business.statusId = info.statusId;
    state.business.annualRevenueId = info.annualRevenueId;
    state.business.dispatchPriorityId = info.dispatchPriorityId;
    state.business.distributorId = info.distributorId;
    state.business.accountId = info.accountId;
    state.business.monthlyRoId = info.monthlyRoId;
    state.business.manufacturers = info.manufacturers || [];
    state.business.services = info.services || [];

    state.business.isCorporateAccount = info.isCorporateAccount;
    state.business.isAstechClient = info.isAstechClient;
    state.business.isMobileClient = info.isMobileClient;
    state.business.isHunterClient = info.isHunterClient;
    state.business.isSafeliteClient = info.isSafeliteClient;
    state.business.isEnterpriseClient = info.isEnterpriseClient;
    state.business.isSolera = info.isSolera;
    state.business.soleraSiteIdReference = info.soleraSiteIdReference;
    state.business.isOnyxClient = info.IsOnyxClient;
    state.business.onyxClientReference = info.OnyxClientReference;
    state.business.isCapLinkMember = info.isCaplinkMember;
    state.business.capricornNumber = info.capricornNumber;
    state.business.salesRepId = info.salesRepId;
    state.business.referralSourceId = info.referralSourceId;
    state.business.locationCountId = info.locationCountId;
    state.business.oemCertifications = info.oemCertifications || [];
    state.business.insuranceDepartments = info.insuranceDepartments || [];

    state.business.billing.currencyId = info.billing.currencyId;
    state.business.billing.isDemo = info.billing.isDemo;
    state.business.billing.isRecurring = info.billing.isRecurring === null ? false : info.billing.isRecurring;
    state.business.billing.periodAmount = info.billing.periodAmount;
    state.business.billing.periodId = info.billing.periodId;

    state.business.reportingGroupId = info.reportingGroupId;
    state.business.parentId = info.ParentId;
    state.business.grandparentId = info.GrandparentId;
  } else {
    state.business.annualRevenueId = null;
    state.business.dispatchPriorityId = null;
    state.business.distributorId = null;
    state.business.accountId = null;
    state.business.monthlyRoId = null;
    state.business.manufacturers = [];
    state.business.services = [];

    state.business.isAstechClient = false;
    state.business.isMobileClient = false;
    state.business.isEnterpriseClient = false;
    state.business.isHunterClient = false;
    state.business.isSafeliteClient = false;
    state.business.isSolera = false;
    state.business.soleraSiteIdReference = null;
    state.business.salesRepId = null;
    state.business.referralSourceId = null;
    state.business.locationCountId = null;
    state.business.isCapLinkMember = false;
    state.business.capricornNumber = null;
    state.business.isOnyxClient = false;
    state.business.onyxClientReference = null;
    state.business.oemCertifications = [];
    state.business.insuranceDepartments = [];

    state.business.billing.currencyId = null;
    state.business.billing.isDemo = false;
    state.business.billing.isRecurring = false;
    state.business.billing.periodAmount = null;
    state.business.billing.periodId = null;

    state.business.reportingGroupId = null;
    state.business.parentId = null;
    state.business.grandparentId = null;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USERS"], function (state, users) {
  state.business.users = users || [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BILLING"], function (state, billing) {
  state.business.billing = billing;
  state.business.billing.oemChargeableProducts = billing.oemChargeableProducts || [];
  state.business.billing.isCurrencyIdSavedInDatabase = billing.currencyId > 0;
  state.business.billing.initialCurrencyId = billing.currencyId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PROMOTION"], function (state, promotion) {
  if (promotion) {
    state.business.promotion = promotion;
    var date = new Date(promotion.startDate);
    var dateStart = '' + date.getFullYear() + '-' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate();
    date = new Date(promotion.endDate);
    state.business.promotion.startDate = dateStart;
    var dateEnd = '' + date.getFullYear() + '-' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate();
    state.business.promotion.endDate = dateEnd;
    console.log(dateStart);
  } else {
    var defaultDate = new Date();

    var dateformat = '' + defaultDate.getFullYear() + '-' + (defaultDate.getMonth() + 1 > 9 ? '' : '0') + (defaultDate.getMonth() + 1) + '-' + (defaultDate.getDate() > 9 ? '' : '0') + defaultDate.getDate();
    state.business.promotion.endDate = dateformat;
    state.business.promotion.startDate = dateformat;
    state.business.promotion.startProductId = 0;
    state.business.promotion.endProductId = 0;
    state.business.promotion.promotionType = 0;
    state.business.promotion.numberOfScans = 0;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNTS"], function (state, discounts) {
  state.business.discounts = discounts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNTS_PRODUCT_ADDS"], function (state, discounts) {
  state.business.discountsProductAdds = discounts;
  state.business.discountsProductAdds.forEach(function (element) {
    element.isChanged = false;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NOTES"], function (state, notes) {
  state.business.notes = notes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NOTE_TO_LIST"], function (state, note) {
  state.business.notes.unshift(note);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_PERIOD_DATA"], function (state) {
  state.business.billing.periodId = null;
  state.business.billing.periodAmount = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ROLES"], function (state, roles) {
  state.roles = roles;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESSES_FOUND"], function (state, found) {
  state.businessesFound = found;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SOURCE"], function (state, source) {
  state.source = source;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ALL_BUSINESSES"], function (state, businesses) {
  state.allBusinesses = businesses;
}), _types$INIT_BUSINESS_);

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: { value: '' },
  activeTab: 'Location',
  tabs: ['Location', 'Biz Info', 'User List', 'Billing', 'Promotion', 'Devices', 'Notes', 'Requests'],
  activeMappingType: null,
  loading: {
    upsertBusiness: false,
    upsertBusinessUser: false,
    upsertBusinessBilling: false,
    upsertBusinessNote: false,
    upsertBusinessInfo: false,
    upsertBusinessPromotion: false,
    swapShop: false
  },

  business: {},
  businesses: [],
  products: [],
  roles: [],
  businessesFound: [],
  source: null,
  allBusinesses: { results: [] }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewRecommendation: function cancelNewRecommendation(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWRECOMMENDATION');
  },
  setRecommendationActivation: function setRecommendationActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_RECOMMENDATIONACTIVATION', data);
  },
  addRecommendation: function addRecommendation(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_RECOMMENDATION', data);
  },
  setRecommendation: function setRecommendation(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_RECOMMENDATION', data);
  },
  getCalibrationRecommendation: function getCalibrationRecommendation(_ref5, id) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationRecommendation(id).then(function (response) {
                  commit('SET_RECOMMENDATION', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getCalibrationRecommendations: function getCalibrationRecommendations(_ref6, make) {
    var _this2 = this;

    var commit = _ref6.commit,
        state = _ref6.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationRecommendations(make).then(function (response) {
                  commit('SET_RECOMMENDATIONS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveCalibrationRecommendations: function saveCalibrationRecommendations(_ref7, data) {
    var _this3 = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveCalibrationRecommendations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  deleteCalibrationRecommendation: function deleteCalibrationRecommendation(_ref8, id) {
    var _this4 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteCalibrationRecommendation(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  recommendations: function recommendations(state) {
    return state.recommendations;
  },
  recommendation: function recommendation(state) {
    return state.recommendation;
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(251);



var _types$CANCEL_NEWRECO;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWRECO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWRECOMMENDATION"], function (state) {
  state.recommendations = state.recommendations.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATIONACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_RECOMMENDATION"], function (state, recommendation) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.recommendations.unshift(recommendation);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATIONS"], function (state, data) {
  state.recommendations = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.recommendations = data;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.isChanged = false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATION"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        switch (data.name) {
          case 'IsInactive':
            item.isInactive = data.value;
            break;
          case 'Nickname':
            item.nickname = data.value;
            break;
          case 'VehicleMake':
            item.vehicleMake = data.value;
            break;
          case 'VehicleMakeName':
            item.vehicleMakeName = parseInt(data.value);
            break;
          case 'Recommendation':
            item.recommendation = data.value;
            break;
        }
        item.isChanged = true;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWRECO);

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    recommendations: [],
    recommendation: null
  };
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATION", function() { return SET_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATIONS", function() { return SET_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_RECOMMENDATION", function() { return ADD_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWRECOMMENDATION", function() { return CANCEL_NEWRECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATIONACTIVATION", function() { return SET_RECOMMENDATIONACTIVATION; });
var SET_RECOMMENDATION = 'SET_RECOMMENDATION';
var SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';
var ADD_RECOMMENDATION = 'ADD_RECOMMENDATION';
var CANCEL_NEWRECOMMENDATION = 'CANCEL_NEWRECOMMENDATION';
var SET_RECOMMENDATIONACTIVATION = 'SET_RECOMMENDATIONACTIVATION';

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(116);






/* harmony default export */ __webpack_exports__["default"] = ({
  initSendBird: function initSendBird(_ref, apiId) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["INIT_SENDBIRD"], apiId);
  },
  setSearchTerm: function setSearchTerm(_ref2, search) {
    var commit = _ref2.commit;

    if (search.for === 'user') {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM_USER"], search.text);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], search.text);
    }
  },
  setPageSize: function setPageSize(_ref3, page) {
    var commit = _ref3.commit;

    if (page.for === 'user') {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE_USER"], page.size);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], page.size);
    }
  },
  resetChannels: function resetChannels(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_CHANNELS"]);
  },
  getChannels: function getChannels(_ref5, searchOptions) {
    var _this = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChannels(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNELS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setChannelChecked: function setChannelChecked(_ref6, data) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNEL_CHECKED"], data);
  },
  resetUsers: function resetUsers(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_USERS"]);
  },
  getUsers: function getUsers(_ref8, searchOptions) {
    var _this2 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatUsers(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USERS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setUserChecked: function setUserChecked(_ref9, data) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER_CHECKED"], data);
  },
  getUserChannels: function getUserChannels(_ref10, options) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatUserChannels(options).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNELS"], response.data);
        resolve(response);
      });
    });
  },
  setMessageChecked: function setMessageChecked(_ref11, data) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_MESSAGE_CHECKED"], data);
  },
  resetMessageList: function resetMessageList(_ref12) {
    var commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_MESSAGES"]);
  },
  addMessageToList: function addMessageToList(_ref13, message, hasmore) {
    var commit = _ref13.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["ADD_MESSAGE"], message, hasmore);
  },
  setTyping: function setTyping(_ref14, channel) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TYPING"], channel);
  },
  removeChannels: function removeChannels(_ref15, data) {
    var commit = _ref15.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeChannels(data).then(function (response) {
        resolve(response);
      });
    });
  },
  removeUsers: function removeUsers(_ref16, data) {
    var commit = _ref16.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeUsers(data).then(function (response) {
        resolve(response);
      });
    });
  },
  saveMessage: function saveMessage(_ref17, data) {
    var commit = _ref17.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveMessage(data).then(function (response) {
        resolve(response);
      });
    });
  },
  saveTranslatedMessage: function saveTranslatedMessage(_ref18, data) {
    var commit = _ref18.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTranslatedMessage(data).then(function (response) {
        resolve(response);
      });
    });
  },
  updateChannelMessageCount: function updateChannelMessageCount(_ref19, data) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNEL_MESSAGE_COUNT"], data);
  },
  getChatHistory: function getChatHistory(_ref20, id) {
    var commit = _ref20.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatHistory(id).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_MESSAGES"], response.data);
        resolve(response);
      });
    });
  },
  resetRequests: function resetRequests(_ref21) {
    var commit = _ref21.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_REQUESTS"]);
  },
  getServiceRequestsWithMessages: function getServiceRequestsWithMessages(_ref22, search) {
    var commit = _ref22.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestsWithMessages(search).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_REQUESTS"], response.data);
        resolve(response);
      });
    });
  },
  saveChatMessages: function saveChatMessages(_ref23, data) {
    var commit = _ref23.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_CHANNELS"]);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveChatMessages(data).then(function (response) {
        resolve(response);
      });
    });
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  channels: function channels(state) {
    return state.channels;
  },
  users: function users(state) {
    return state.users;
  },
  userChannels: function userChannels(state) {
    return state.userChannels;
  },
  messages: function messages(state) {
    return state.messages;
  },
  isTyping: function isTyping(state) {
    return state.isTyping;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  token: function token(state) {
    return state.token;
  },
  pageSizeUser: function pageSizeUser(state) {
    return state.pageSizeUser;
  },
  searchTermUser: function searchTermUser(state) {
    return state.searchTermUser;
  },
  tokenUser: function tokenUser(state) {
    return state.tokenUser;
  },
  isChannelChecked: function isChannelChecked(state) {
    return state.isChannelChecked;
  },
  isChannelNotSaved: function isChannelNotSaved(state) {
    return state.isChannelNotSaved;
  },
  isUserChecked: function isUserChecked(state) {
    return state.isUserChecked;
  },
  requests: function requests(state) {
    return state.requests;
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sendbird__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sendbird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sendbird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendbird_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(94);



var _types$INIT_SENDBIRD$;






/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_SENDBIRD$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_SENDBIRD"], function (state, apiId) {
  __WEBPACK_IMPORTED_MODULE_4__sendbird_js__["default"].sendbird = new __WEBPACK_IMPORTED_MODULE_3_sendbird___default.a({
    appId: apiId
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  state.searchTerm = text;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, pageSize) {
  state.pageSize = pageSize;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM_USER"], function (state, text) {
  state.searchTermUser = text;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE_USER"], function (state, pageSize) {
  state.pageSizeUser = pageSize;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_CHANNELS"], function (state) {
  state.channels = [];
  state.token = '';
  state.searchTerm = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNELS"], function (state, data) {
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.channels), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var channel = _step.value;

        channel.isChecked = false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    state.channels = state.channels.concat(data.channels);
    state.token = data.next;
  }
  state.isChannelChecked = false;
  state.isChannelNotSaved = false;
  var anyChecked = false;
  var anyNotSaved = false;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _channel = _step2.value;

      if (_channel.isChecked) {
        anyChecked = true;
        if ((_channel.status.includes('Completed') || _channel.status === 'Cancelled' || _channel.status === 'Voided RO') && parseInt(_channel.chatMessageCount) === 0) {
          anyNotSaved = true;
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  state.isChannelNotSaved = anyNotSaved;
  state.isChannelChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNEL_MESSAGE_COUNT"], function (state, data) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var channel = _step3.value;

      if (channel.name === data.channel) {
        if (channel.chatMessageCount > 0) {
          channel.chatMessageCount += data.count;
        } else {
          channel.chatMessageCount = data.count;
        }
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNEL_CHECKED"], function (state, data) {
  state.isChannelChecked = false;
  state.isChannelNotSaved = false;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var channel = _step4.value;

      if (channel.name === data.name) {
        channel.isChecked = data.isChecked;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var anyChecked = false;
  var anyNotSaved = false;
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _channel2 = _step5.value;

      if (_channel2.isChecked) {
        anyChecked = true;
        if ((_channel2.status.includes('Completed') || _channel2.status === 'Cancelled' || _channel2.status === 'Voided RO') && parseInt(_channel2.chatMessageCount) === 0) {
          anyNotSaved = true;
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  state.isChannelNotSaved = anyNotSaved;
  state.isChannelChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_USERS"], function (state) {
  state.users = [];
  state.tokenUser = '';
  state.searchTermUser = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USERS"], function (state, data) {
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.users), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var user = _step6.value;

        user.isChecked = false;
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    state.users = state.users.concat(data.users);
    state.tokenUser = data.next;
    state.isUserChecked = false;
    var anyChecked = false;
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var _user = _step7.value;

        if (_user.isChecked) {
          anyChecked = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    state.isUserChecked = anyChecked;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER_CHECKED"], function (state, data) {
  state.isUserChecked = false;
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var user = _step8.value;

      if (user.user_id === data.userId) {
        user.isChecked = data.isChecked;
        break;
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  var anyChecked = false;
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var _user2 = _step9.value;

      if (_user2.isChecked) {
        anyChecked = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  state.isUserChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_MESSAGES"], function (state) {
  state.messages = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGE_CHECKED"], function (state, data) {
  console.log('Set Message Checked');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MESSAGE"], function (state, message) {
  var userProfile = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['authorize/userProfile'];
  var language = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['authorize/language'];
  var type = 'received';
  var name = message._sender.nickname;
  if (userProfile.email === message._sender.userId) {
    type = 'sent';
    name = 'me';
  }
  var messageText = message.message;
  if (message.translations[language] !== undefined && message.translations[language] !== null) {
    messageText = message.translations[language];
  }
  var data = {
    name: name,
    type: type,
    text: messageText,
    avatar: '',
    createdAt: message.createdAt,
    email: message._sender.userId,
    messageId: message.messageId
  };
  state.messages.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TYPING"], function (state, channel) {
  state.isTyping = channel.isTyping();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGES"], function (state, data) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_REQUESTS"], function (state) {
  state.requests = [];
  state.token = '';
  state.searchTerm = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_REQUESTS"], function (state, data) {
  state.requests = data;
}), _types$INIT_SENDBIRD$);

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    channels: [],
    users: [],
    userChannels: [],
    messages: [],
    isTyping: false,
    pageSize: 20,
    searchTerm: '',
    token: '',
    pageSizeUser: 20,
    searchTermUser: '',
    tokenUser: '',
    isChannelChecked: false,
    isChannelNotSaved: false,
    isUserChecked: false,
    requests: []
  };
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIGURATION", function() { return CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONFIGURATION", function() { return SET_CONFIGURATION; });
var CONFIGURATION = 'CONFIGURATION';
var SET_CONFIGURATION = 'SET_CONFIGURATION';

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(148);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  downloadRequests: function downloadRequests(_ref7, data) {
    var _this = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequests(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  downloadRequestStatistics: function downloadRequestStatistics(_ref8, data) {
    var _this2 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequestStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadDeviceStatistics: function downloadDeviceStatistics(_ref9, data) {
    var _this3 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadDeviceStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  downloadActivationCardStatistics: function downloadActivationCardStatistics(_ref10, data) {
    var _this4 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadActivationCardStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadBusinessAccountInfo: function downloadBusinessAccountInfo(_ref11, data) {
    var _this5 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadBusinessAccountInfo(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  downloadDeviceShipments: function downloadDeviceShipments(_ref12, data) {
    var _this6 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadDeviceShipments(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  downloadRequestsAdhoc: function downloadRequestsAdhoc(_ref13, data) {
    var _this7 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequestsAdhoc(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getDataSchema: function getDataSchema(_ref14, name) {
    var _this8 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDataSchema(name).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCHEMA"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getChoices: function getChoices(_ref15, data) {
    var _this9 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChoices(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getQueryTemplates: function getQueryTemplates(_ref16) {
    var _this10 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getQueryTemplates().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_QUERY_TEMPLATES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  saveQueryTemplate: function saveQueryTemplate(_ref17, data) {
    var _this11 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveQueryTemplate(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  removeQueryTemplate: function removeQueryTemplate(_ref18, data) {
    var _this12 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeQueryTemplate(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  setCurrentTemplate: function setCurrentTemplate(_ref19, template) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CURRENT_TEMPLATE"], template);
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  requests: function requests(state) {
    return state.requests;
  },
  totalRequests: function totalRequests(state) {
    return state.totalRequests;
  },
  schema: function schema(state) {
    return state.schema;
  },
  queryTemplates: function queryTemplates(state) {
    return state.queryTemplates;
  },
  logicChoices: function logicChoices(state) {
    return state.logicChoices;
  },
  categoryChoices: function categoryChoices(state) {
    return state.categoryChoices;
  },
  currentTemplate: function currentTemplate(state) {
    return state.currentTemplate;
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(148);



var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SCHEMA"], function (state, data) {
  state.schema = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_QUERY_TEMPLATES"], function (state, data) {
  state.queryTemplates = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_REQUESTS"], function (state, data) {
  state.totalRequests = 0;
  state.requests = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalRequests = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.requests = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CURRENT_TEMPLATE"], function (state, template) {
  state.currentTemplate = template;
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    requests: [],
    totalRequests: 0,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Id',
    status: '',
    filterBy: 0,
    schema: [],
    queryTemplates: [],
    logicChoices: [{ name: '', value: 0 }, { name: 'and', value: 1 }, { name: 'or', value: 2 }],
    categoryChoices: [{ name: 'All', value: 0, checked: false }, { name: 'Scan Type', value: 1, checked: false }, { name: 'Status', value: 2, checked: false }, { name: 'Tech', value: 3, checked: false }, { name: 'Location', value: 4, checked: false }, { name: 'Country', value: 5, checked: false }, { name: 'Make', value: 6, checked: false }, { name: 'Time Stats', value: 7, checked: false }],
    currentTemplate: null
  };
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(149);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  clearDevices: function clearDevices(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["CLEAR_DEVICES"]);
  },
  clearFound: function clearFound(_ref8) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["CLEAR_FOUND_DEVICES"]);
  },
  initDeviceModel: function initDeviceModel(_ref9, data) {
    var commit = _ref9.commit;

    console.log('test', data);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceById(data).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["INIT_DEVICE_DATA"], response.data);
        resolve(response);
      });
    });
  },
  setActiveTab: function setActiveTab(_ref10, tab) {
    var commit = _ref10.commit,
        state = _ref10.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ACTIVE_TAB"], tab);
  },
  setSource: function setSource(_ref11, source) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SOURCE"], source);
  },
  getDevice: function getDevice(_ref12, serialNumber) {
    var _this = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDevice(serialNumber).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DEVICE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getDeviceById: function getDeviceById(_ref13, id) {
    var _this2 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceById(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DEVICE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getDeviceFileById: function getDeviceFileById(_ref14, id) {
    var _this3 = this;

    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceFileById(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DEVICEFILE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getDevices: function getDevices(_ref15, searchOptions) {
    var _this4 = this;

    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDevicefiles: function getDevicefiles(_ref16, searchOptions) {
    var _this5 = this;

    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getdevicefiles(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DEVICEFILES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  searchDevices: function searchDevices(_ref17, searchOptions) {
    var _this6 = this;

    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FOUND_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getAssociatedDevices: function getAssociatedDevices(_ref18, searchOptions) {
    var _this7 = this;

    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  if (searchOptions.deviceId > 0) {
                    response.data = response.data.filter(function (obj) {
                      return obj.Id !== searchOptions.deviceId;
                    });
                  }

                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ASSOCIATED_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  activateDevice: function activateDevice(_ref19, data) {
    var _this8 = this;

    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].activateDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getDeviceActivation: function getDeviceActivation(_ref20, data) {
    var _this9 = this;

    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceActivation(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  downloadAllTools: function downloadAllTools(_ref21, id) {
    var _this10 = this;

    var commit = _ref21.commit,
        dispatch = _ref21.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadAllTools(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  getTools: function getTools(_ref22, searchOptions) {
    var _this11 = this;

    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTools(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TOOLS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  updateDeviceFile: function updateDeviceFile(_ref23, data) {
    var _this12 = this;

    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateDeviceFile(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  updateDevice: function updateDevice(_ref24, data) {
    var _this13 = this;

    var commit = _ref24.commit,
        dispatch = _ref24.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  upsertDeviceShipment: function upsertDeviceShipment(_ref25, data) {
    var _this14 = this;

    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertDeviceShipment(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  createDevice: function createDevice(_ref26, data) {
    var _this15 = this;

    var commit = _ref26.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].createDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  getToolMakes: function getToolMakes(_ref27, id) {
    var _this16 = this;

    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getToolMakes(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TOOL_MAKES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  addToolMake: function addToolMake(_ref28, data) {
    var _this17 = this;

    var commit = _ref28.commit,
        dispatch = _ref28.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].addToolMake(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  deleteToolMake: function deleteToolMake(_ref29, id) {
    var _this18 = this;

    var commit = _ref29.commit,
        dispatch = _ref29.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteToolMake(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  assignDevice: function assignDevice(_ref30, data) {
    var _this19 = this;

    var commit = _ref30.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].assignDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  activeTab: function activeTab(state) {
    return state.activeTab;
  },
  tabs: function tabs(state) {
    return state.tabs;
  },
  source: function source(state) {
    return state.source;
  },
  device: function device(state) {
    return state.device;
  },
  devices: function devices(state) {
    return state.devices;
  },
  totalDevices: function totalDevices(state) {
    return state.totalDevices;
  },
  deviceFiles: function deviceFiles(state) {
    return state.deviceFiles;
  },
  deviceFile: function deviceFile(state) {
    return state.deviceFile;
  },
  totalDeviceFiles: function totalDeviceFiles(state) {
    return state.totalDeviceFiles;
  },
  currentDevice: function currentDevice(state) {
    return state.currentDevice;
  },
  tools: function tools(state) {
    return state.tools;
  },
  totalTools: function totalTools(state) {
    return state.totalTools;
  },
  toolMakes: function toolMakes(state) {
    return state.toolMakes;
  },
  totalFoundDevices: function totalFoundDevices(state) {
    return state.totalFoundDevices;
  },
  foundDevices: function foundDevices(state) {
    return state.foundDevices;
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(149);



var _types$INIT_DEVICE_DA;



/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_DEVICE_DA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_DEVICE_DATA"], function (state, data) {
  console.log('init device', data);
  state.device = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICE"], function (state, data) {
  console.log('SET_DEVICE', data);
  state.device = data;
  state.currentDevice = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICEFILE"], function (state, data) {
  console.log('SET_DEVICEFILE', data);
  state.deviceFile = data;
  state.currentDeviceFile = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICES"], function (state, data) {
  state.totalDevices = 0;
  state.devices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalDevices = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.devices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICEFILES"], function (state, data) {
  state.totalDeviceFiles = 0;
  state.devicefiles = [];
  console.log('SET_DEVICE_FILES', data);
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalDeviceFiles = data[0].TotalItems;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.deviceFiles = data;
      console.log('SET_DEVICE_FILES', state.deviceFiles);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FOUND_DEVICES"], function (state, data) {
  state.totalFoundDevices = 0;
  state.foundDevices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalFoundDevices = data[0].TotalItems;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      state.foundDevices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ASSOCIATED_DEVICES"], function (state, data) {
  state.totalAssociatedFoundDevices = 0;
  state.foundAssociatedDevices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalAssociatedFoundDevices = data[0].TotalItems;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      state.foundAssociatedDevices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["CLEAR_FOUND_DEVICES"], function (state) {
  state.totalFoundDevices = 0;
  state.foundDevices = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["CLEAR_DEVICES"], function (state) {
  state.totalDevices = 0;
  state.devices = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TOOLS"], function (state, data) {
  state.totalTools = 0;
  state.tools = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalTools = data[0].TotalItems;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      state.tools = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ACTIVE_TAB"], function (state, tab) {
  state.activeTab = tab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TOOL_MAKES"], function (state, data) {
  state.toolMakes = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.toolMakes = data;
    }
  }
}), _types$INIT_DEVICE_DA);

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    device: null,
    devices: [],
    totalDevices: 0,
    deviceFiles: [],
    deviceFile: null,
    totalDeviceFiles: 0,
    tools: [],
    totalTools: 0,
    toolMakes: [],
    connectedDevices: [],
    currentDevice: null,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Name',
    status: '',
    filterBy: 0,
    totalFoundDevices: 0,
    foundDevices: [],
    activeTab: 'Device',
    tabs: ['Device', 'Location', 'Shipment']
  };
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  getFiles: function getFiles(_ref, path) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getFiles(path).then(function (response) {
                  commit('SET_FILES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getBase64File: function getBase64File(_ref2, file) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getBase64File(file).then(function (response) {
                  commit('SET_FILE', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getThumbs: function getThumbs(_ref3, path) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getThumbs(path).then(function (response) {
                  commit('SET_THUMBS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  uploadBase64File: function uploadBase64File(_ref4, data) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadBase64File(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  files: function files(state) {
    return state.files;
  },
  file: function file(state) {
    return state.file;
  },
  thumbs: function thumbs(state) {
    return state.thumbs;
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(269);


var _types$SET_FILES$type;


/* harmony default export */ __webpack_exports__["default"] = (_types$SET_FILES$type = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILES"], function (state, files) {
  state.files = files;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILE"], function (state, file) {
  state.file = file;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_THUMBS"], function (state, thumbs) {
  state.thumbs = thumbs;
}), _types$SET_FILES$type);

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    files: [],
    file: null,
    thumbs: []
  };
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILES", function() { return SET_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILE", function() { return SET_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_THUMBS", function() { return SET_THUMBS; });
var SET_FILES = 'SET_FILES';
var SET_FILE = 'SET_FILE';
var SET_THUMBS = 'SET_THUMBS';

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(150);







/* harmony default export */ __webpack_exports__["default"] = ({
  initWorkOrderMaintenance: function initWorkOrderMaintenance(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["INIT_WORKORDER"]);
  },
  addInsurance: function addInsurance(_ref2, data) {
    var _this = this;

    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].addInsurance(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getWorkOrderMaintenance: function getWorkOrderMaintenance(_ref3, workOrder) {
    var _this2 = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getWorkOrderMaintenance(workOrder).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_WORKORDER"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveWorkOrderMaintenance: function saveWorkOrderMaintenance(_ref4, data) {
    var _this3 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveWorkOrderMaintenance(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fixDispatchTimes: function fixDispatchTimes(_ref5) {
    var _this4 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fixDispatchTimes().then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  cancelPendingRequests: function cancelPendingRequests(_ref6, location) {
    var _this5 = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].cancelPendingRequests(location).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  searchTechnicians: function searchTechnicians(_ref7, searchTerm) {
    var _this6 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].searchTechnicians(searchTerm).then(function (response) {
                  console.log('Search Techs', response);
                  var _technicians = [];
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var tech = _step.value;

                      var technician = {
                        name: tech.FamilyName + ', ' + tech.GivenName + ' (' + tech.Username + ')',
                        code: tech.Id,
                        lastName: tech.FamilyName
                      };
                      _technicians.push(technician);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_TECHNICIANS"], _technicians);
                  resolve(_technicians);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  resetTechnician: function resetTechnician(_ref8, data) {
    var _this7 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].resetTechnician(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  workOrder: function workOrder(state) {
    return state.workOrder;
  },
  technicians: function technicians(state) {
    return state.technicians;
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(150);


var _types$SET_TECHNICIAN;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_TECHNICIAN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["SET_TECHNICIANS"], function (state, data) {
  state.technicians = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["SET_WORKORDER"], function (state, workOrder) {
  state.workOrder = workOrder;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["INIT_WORKORDER"], function (state) {
  state.workOrder = {
    Id: 0,
    Location: {
      Id: 0,
      Name: ''
    },
    WorkOrder: {
      CreatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      },
      UpdatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      }
    },
    ScanReport: {
      Status: '',
      CreatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      },
      UpdatedDate: new Date(),
      UpdatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      }
    },
    Invoice: {
      Number: '',
      Amount: ''
    }
  };
}), _types$SET_TECHNICIAN);

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    workOrder: null,
    technicians: []
  };
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewMake: function cancelNewMake(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWMAKE');
  },
  setMakeActivation: function setMakeActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_MAKEACTIVATION', data);
  },
  addMake: function addMake(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_MAKE', data);
  },
  setMake: function setMake(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_MAKE', data);
  },
  getMakes: function getMakes(_ref5) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.makes = [];
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getMakes(true).then(function (response) {
                  commit('SET_MAKES', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveMakes: function saveMakes(_ref6, data) {
    var _this2 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveMakes(data, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  makes: function makes(state) {
    return state.makes;
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(278);



var _types$CANCEL_NEWMAKE;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWMAKE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWMAKE"], function (state) {
  state.makes = state.makes.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKEACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isInactive = data.isInactive;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MAKE"], function (state, make) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.makes.unshift(make);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKES"], function (state, data) {
  state.makes = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        state.makes.push({
          id: item.id,
          make: item.make,
          isInactive: item.isInactive,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKE"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        item.make = data.make;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWMAKE);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    makes: []
  };
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKES", function() { return SET_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKE", function() { return SET_MAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MAKE", function() { return ADD_MAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWMAKE", function() { return CANCEL_NEWMAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKEACTIVATION", function() { return SET_MAKEACTIVATION; });
var SET_MAKES = 'SET_MAKES';
var SET_MAKE = 'SET_MAKE';
var ADD_MAKE = 'ADD_MAKE';
var CANCEL_NEWMAKE = 'CANCEL_NEWMAKE';
var SET_MAKEACTIVATION = 'SET_MAKEACTIVATION';

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewMessage: function cancelNewMessage(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWMESSAGE');
  },
  setMessageActivation: function setMessageActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_MESSAGEACTIVATION', data);
  },
  addMessage: function addMessage(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_MESSAGE', data);
  },
  setMessage: function setMessage(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_MESSAGE', data);
  },
  getMessages: function getMessages(_ref5) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookup({ key: 'messages.precanned', showAll: true }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  commit('SET_MESSAGES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveMessages: function saveMessages(_ref6, data) {
    var _this2 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].savePreCannedMessages(data, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  messages: function messages(state) {
    return state.messages;
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(283);



var _types$CANCEL_NEWMESS;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWMESS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWMESSAGE"], function (state) {
  state.messages = state.messages.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGEACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isActive = data.isActive;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MESSAGE"], function (state, message) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.messages.unshift(message);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGES"], function (state, data) {
  state.messages = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        state.messages.push({
          id: item.id,
          message: item.text,
          isActive: item.isActive,
          sortOrder: item.sortOrder,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGE"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        item.message = data.message;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWMESS);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    messages: []
  };
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGES", function() { return SET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGE", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MESSAGE", function() { return ADD_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWMESSAGE", function() { return CANCEL_NEWMESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGEACTIVATION", function() { return SET_MESSAGEACTIVATION; });
var SET_MESSAGES = 'SET_MESSAGES';
var SET_MESSAGE = 'SET_MESSAGE';
var ADD_MESSAGE = 'ADD_MESSAGE';
var CANCEL_NEWMESSAGE = 'CANCEL_NEWMESSAGE';
var SET_MESSAGEACTIVATION = 'SET_MESSAGEACTIVATION';

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(151);






/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationHomepageMessage: function getCalibrationHomepageMessage(_ref) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationHomepageMessage().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CALIBRATION_HOMEPAGE_MESSAGE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveCalibrationHomepageMessage: function saveCalibrationHomepageMessage(_ref2, data) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('saveCalibrationHomepageMessage');

              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var request = {
                  Text: data.homepageMessage,
                  IsActive: data.isActive
                };

                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveCalibrationHomepageMessage(request).then(function (response) {
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  calibrationHomepageMessage: function calibrationHomepageMessage(state) {
    return state.calibrationHomepageMessage;
  }

});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(151);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["SET_CALIBRATION_HOMEPAGE_MESSAGE"], function (state, data) {
  state.calibrationHomepageMessage = data;
}));

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    calibrationHomepageMessage: null
  };
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(152);






/* harmony default export */ __webpack_exports__["default"] = ({
  setStandardOpeningHours: function setStandardOpeningHours(_ref, openingHours) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], openingHours);
  },
  setHolidayOpeningHours: function setHolidayOpeningHours(_ref2, openingHours) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], openingHours);
  },
  getStandardOpeningHours: function getStandardOpeningHours(_ref3, tenantId) {
    var _this = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStandardOpeningHours(tenantId).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getHolidayOpeningHours: function getHolidayOpeningHours(_ref4, tenantId) {
    var _this2 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getHolidayOpeningHours(tenantId).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getStandardOpeningHoursForList: function getStandardOpeningHoursForList(_ref5) {
    var _this3 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStandardOpeningHoursForList().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getTenantDetails: function getTenantDetails(_ref6) {
    var _this4 = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTenantDetails().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TENANT_DETAILS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  setSelectedTenant: function setSelectedTenant(_ref7, tenantID) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var tenantDetails = null;

    try {
      tenantDetails = typeof state.tenantDetails === 'string' ? JSON.parse(state.tenantDetails) : state.tenantDetails;
    } catch (error) {
      console.error('Invalid JSON structure:', error);
      return;
    }

    if (tenantDetails && Array.isArray(tenantDetails.Items)) {
      var tenant = tenantDetails.Items.find(function (t) {
        return t.ID === tenantID;
      });

      if (tenant) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SELECTED_TENANT"], tenant);
      }
    }
  },
  updateTenantSupportEmail: function updateTenantSupportEmail(_ref8, data) {
    var _this5 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateTenantSupportEmail(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TENANT_DETAILS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateStandardOpeningHours: function updateStandardOpeningHours(_ref9, data) {
    var _this6 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateStandardOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  updateHolidayOpeningHours: function updateHolidayOpeningHours(_ref10, data) {
    var _this7 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateHolidayOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  insertHolidayOpeningHours: function insertHolidayOpeningHours(_ref11, data) {
    var _this8 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].insertHolidayOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  deleteHolidaySchedule: function deleteHolidaySchedule(_ref12, data) {
    var _this9 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteHolidaySchedule(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getOutOfHoursAuditLog: function getOutOfHoursAuditLog(_ref13, searchOptions) {
    var _this10 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getOutOfHoursAuditLog(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_OUT_OF_HOURS_AUDIT_LOG"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  setPageSize: function setPageSize(_ref14, pageSize) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref15, sortDir) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref16, orderBy) {
    var commit = _ref16.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  standardOpeningHours: function standardOpeningHours(state) {
    return state.standardOpeningHours;
  },
  holidayOpeningHours: function holidayOpeningHours(state) {
    return state.holidayOpeningHours;
  },
  tenantDetails: function tenantDetails(state) {
    return state.tenantDetails;
  },
  selectedTenant: function selectedTenant(state) {
    return state.selectedTenant;
  },
  totalLogEntries: function totalLogEntries(state) {
    return state.totalLogEntries;
  },
  outOfHoursAuditLog: function outOfHoursAuditLog(state) {
    return state.outOfHoursAuditLog;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(152);


var _types$SET_STANDARD_O;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_STANDARD_O = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_STANDARD_OPENING_HOURS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.standardOpeningHours = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_HOLIDAY_OPENING_HOURS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.holidayOpeningHours = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_TENANT_DETAILS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.tenantDetails = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SELECTED_TENANT"], function (state, tenant) {
  state.selectedTenant = tenant;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["UPDATE_TENANT_SUPPORT_EMAIL"], function (state, _ref) {
  var tenantID = _ref.tenantID,
      email = _ref.email;

  var tenants = JSON.parse(state.tenantDetails);
  var tenant = tenants.find(function (t) {
    return t.ID === tenantID;
  });
  if (tenant) {
    tenant.SupportEmail = email;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_OUT_OF_HOURS_AUDIT_LOG"], function (state, data) {
  state.totalLogEntries = 0;
  state.outOfHoursAuditLog = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalLogEntries = data[0].TotalItems;
      state.outOfHoursAuditLog = data;
    }
  }
}), _types$SET_STANDARD_O);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    standardOpeningHours: '',
    holidayOpeningHours: '',
    tenantDetails: '',
    selectedTenant: null,
    totalLogEntries: 0,
    outOfHoursAuditLog: [],
    sortDir: '',
    orderBy: '',
    pageSize: 10
  };
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  addScanTool: function addScanTool(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('ADD_SCANTOOL', data);
  },
  setScanTool: function setScanTool(_ref2, data) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit('SET_SCANTOOL', data);
  },
  cancelNewScanTool: function cancelNewScanTool(_ref3) {
    var commit = _ref3.commit;

    commit('CANCEL_NEWSCANTOOL');
  },
  addReportTemplate: function addReportTemplate(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('ADD_REPORT_TEMPLATE', data);
  },
  setReportTemplate: function setReportTemplate(_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('SET_REPORT_TEMPLATE', data);
  },
  cancelNewReportTemplate: function cancelNewReportTemplate(_ref6) {
    var commit = _ref6.commit;

    commit('CANCEL_NEWREPORTTEMPLATE');
  },
  getScanTools: function getScanTools(_ref7) {
    var _this = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getScanTools().then(function (response) {
                  commit('SET_SCANTOOLS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveScanTool: function saveScanTool(_ref8) {
    var _this2 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.scantools.forEach(function (scantool) {
                if (scantool.isChanged) {
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanTool(scantool, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                      commit('SET_SCANTOOL', {
                        id: 0,
                        name: 'id',
                        value: response.data
                      });
                      scantool.isChanged = false;
                      resolve(response);
                    });
                  });
                }
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeScanTool: function removeScanTool(_ref9, id) {
    var _this3 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeScanTool(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getReportTemplates: function getReportTemplates(_ref10, area) {
    var _this4 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getReportTemplates(area).then(function (response) {
                  commit('SET_REPORT_TEMPLATES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  saveReportTemplate: function saveReportTemplate(_ref11, data) {
    var _this5 = this;

    var commit = _ref11.commit,
        state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.reportTemplates.forEach(function (reportTemplate) {
                if (reportTemplate.isChanged) {
                  console.log('Saving Report Template', reportTemplate);
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveReportTemplate(reportTemplate, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                      console.log('Saved Report Template', response.data);
                      commit('SET_REPORT_TEMPLATE', {
                        id: 0,
                        name: 'id',
                        value: response.data
                      });
                      reportTemplate.isChanged = false;
                      resolve(response);
                    });
                  });
                }
              });

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  removeReportTemplate: function removeReportTemplate(_ref12, id) {
    var _this6 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeReportTemplate(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  saveTechInfo: function saveTechInfo(_ref13, tech) {
    var commit = _ref13.commit;

    commit('SAVE_TECH_INFO', tech);
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  scantools: function scantools(state) {
    return state.scantools;
  },
  reportTemplates: function reportTemplates(state) {
    return state.reportTemplates;
  },
  areas: function areas(state) {
    return state.areas;
  },
  apps: function apps(state) {
    return state.apps;
  },
  techInfo: function techInfo(state) {
    return state.techInfo;
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(296);




var _types$CANCEL_NEWSCAN;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWSCAN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["CANCEL_NEWSCANTOOL"], function (state) {
  state.scantools = state.scantools.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["ADD_SCANTOOL"], function (state, scantool) {
  var cnt = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.scantools), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (cnt === 0) {
    state.scantools.unshift(scantool);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANTOOLS"], function (state, data) {
  state.scantools = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        state.scantools.push({
          id: item.id,
          name: item.name,
          makeId: item.makeId,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          appId: item.appId,
          isInactive: item.isInactive,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANTOOL"], function (state, data) {
  if (state.scantools !== null && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.scantools), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        if (item.id === data.id) {
          item[data.name] = data.value;
          if (item.name === 'id') {
            item.isChanged = false;
          } else {
            item.isChanged = true;
          }
          break;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["CANCEL_NEWREPORTTEMPLATE"], function (state) {
  state.reportTemplates = state.reportTemplates.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["ADD_REPORT_TEMPLATE"], function (state, template) {
  var cnt = 0;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.reportTemplates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  if (cnt === 0) {
    state.reportTemplates.unshift(template);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_REPORT_TEMPLATES"], function (state, data) {
  state.reportTemplates = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var item = _step5.value;

        state.reportTemplates.push({
          id: item.id,
          area: item.area,
          productId: item.productId,
          order: item.order,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          template: item.template,
          appId: item.appId,
          isInactive: item.isInactive,
          isAdd: item.isAdd,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_REPORT_TEMPLATE"], function (state, data) {
  if (state.reportTemplates !== null && data !== null) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.reportTemplates), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var item = _step6.value;

        if (item.id === data.id) {
          item[data.name] = data.value;
          if (item.name === 'id') {
            item.isChanged = false;
          } else {
            item.isChanged = true;
          }
          break;
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SAVE_TECH_INFO"], function (state, tech) {
  localStorage.setItem('techInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tech));
}), _types$CANCEL_NEWSCAN);

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    scantools: [],
    reportTemplates: [],
    apps: [{
      id: 0,
      name: 'All'
    }, {
      id: 1,
      name: 'UK/Europe'
    }, {
      id: 2,
      name: 'Glass US/Canada'
    }, {
      id: 4,
      name: 'Calibration US/Canada'
    }, {
      id: 5,
      name: 'ProTech'
    }],
    areas: [{
      id: 0,
      name: 'Service Details'
    }, {
      id: 1,
      name: 'Recommendations'
    }, {
      id: 2,
      name: 'Scan Readings'
    }, {
      id: 3,
      name: 'Snapshot Data'
    }],
    techInfo: JSON.parse(localStorage.getItem('techInfo'))
  };
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWSCANTOOL", function() { return CANCEL_NEWSCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_SCANTOOL", function() { return ADD_SCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANTOOLS", function() { return SET_SCANTOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANTOOL", function() { return SET_SCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWREPORTTEMPLATE", function() { return CANCEL_NEWREPORTTEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_REPORT_TEMPLATE", function() { return ADD_REPORT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REPORT_TEMPLATES", function() { return SET_REPORT_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REPORT_TEMPLATE", function() { return SET_REPORT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_TECH_INFO", function() { return SAVE_TECH_INFO; });
var CANCEL_NEWSCANTOOL = 'CANCEL_NEWSCANTOOL';
var ADD_SCANTOOL = 'ADD_SCANTOOL';
var SET_SCANTOOLS = 'SET_SCANTOOLS';
var SET_SCANTOOL = 'SET_SCANTOOL';
var CANCEL_NEWREPORTTEMPLATE = 'CANCEL_NEWREPORTTEMPLATE';
var ADD_REPORT_TEMPLATE = 'ADD_REPORT_TEMPLATE';
var SET_REPORT_TEMPLATES = 'SET_REPORT_TEMPLATES';
var SET_REPORT_TEMPLATE = 'SET_REPORT_TEMPLATE';
var SAVE_TECH_INFO = 'SAVE_TECH_INFO';

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(153);






/* harmony default export */ __webpack_exports__["default"] = ({
  resetVisitedStep: function resetVisitedStep(_ref, value) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_VISITED_STEP"], value);
  },
  selectSubmodel: function selectSubmodel(_ref2, id) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_VEHICLE"], id);
  },
  resetSubmodels: function resetSubmodels(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_SUBMODELS"]);
  },
  setSelectedChecklistItems: function setSelectedChecklistItems(_ref4, data) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SELECTED_CHECKLIST_ITEMS"], data);
  },
  setScanProChecklist: function setScanProChecklist(_ref5, data) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CHECKLIST"], data);
  },
  setScanProCriteria: function setScanProCriteria(_ref6, data) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CRITERIA"], data);
  },
  setCriteriaChanged: function setCriteriaChanged(_ref7, value) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CRITERIA_CHANGED"], value);
  },
  setCorporateId: function setCorporateId(_ref8, id) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CORPORATE_ID"], id);
  },
  setStep: function setStep(_ref9, value) {
    var _this = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.isLoading = true;
              if (value !== 99) {
                commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STEP"], value);
                commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_VISITED_STEP"], value);
                state.isLoading = false;
              }

              if (!state.criteriaChanged) {
                _context.next = 5;
                break;
              }

              data = {
                businessId: state.corporateId,
                criteria: state.scanProCriteria,
                checklist: state.scanProChecklist
              };
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanProConfiguration(data).then(function (response) {
                  resolve(response);
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CRITERIA_CHANGED"], false);
                  state.isLoading = false;
                });
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getScanProConfiguration: function getScanProConfiguration(_ref10) {
    var _this2 = this;

    var commit = _ref10.commit,
        state = _ref10.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.isLoading = true;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getScanProConfiguration(state.corporateId).then(function (response) {
                  state.isLoading = false;
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CONFIGURATION"], response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  decodeVin: function decodeVin(_ref11, vin) {
    var _this3 = this;

    var commit = _ref11.commit,
        state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state.isLoading = true;
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].decodeVin(vin).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DECODED_VIN"], { data: response.data, vin: vin });
                  resolve(response);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  evaluateVehicle: function evaluateVehicle(_ref12, data) {
    var _this4 = this;

    var commit = _ref12.commit,
        state = _ref12.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state.isLoading = true;
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].evaluateVehicle(data).then(function (response) {
                  resolve(response);
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_RECOMMENDATION"], response.data);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  saveScanProResults: function saveScanProResults(_ref13, data) {
    var _this5 = this;

    var commit = _ref13.commit,
        state = _ref13.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.isLoading = true;
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanProResults(data).then(function (response) {
                  resolve(response);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  step: function step(state) {
    return state.step;
  },
  visitedStep: function visitedStep(state) {
    return state.visitedStep;
  },
  scanproConfiguration: function scanproConfiguration(state) {
    return state.scanproConfiguration;
  },
  scanProChecklist: function scanProChecklist(state) {
    return state.scanProChecklist;
  },
  scanProCriteria: function scanProCriteria(state) {
    return state.scanProCriteria;
  },
  criteriaChanged: function criteriaChanged(state) {
    return state.criteriaChanged;
  },
  vin: function vin(state) {
    return state.vin;
  },
  decodedVin: function decodedVin(state) {
    return state.decodedVin;
  },
  isDecoded: function isDecoded(state) {
    return state.isDecoded;
  },
  isSubmodelSelected: function isSubmodelSelected(state) {
    return state.isSubmodelSelected;
  },
  submodels: function submodels(state) {
    return state.submodels;
  },
  vehicle: function vehicle(state) {
    return state.vehicle;
  },
  recommendation: function recommendation(state) {
    return state.recommendation;
  },
  safety: function safety(state) {
    return state.safety;
  },
  selectedChecklistItems: function selectedChecklistItems(state) {
    return state.selectedChecklistItems;
  },
  isLoading: function isLoading(state) {
    return state.isLoading;
  },
  corporateId: function corporateId(state) {
    return state.corporateId;
  }
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(153);




var _types$SET_STEP$types;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_STEP$types = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_STEP"], function (state, data) {
  state.step = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["RESET_VISITED_STEP"], function (state, data) {
  state.visitedStep = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_VISITED_STEP"], function (state, currentStep) {
  state.visitedStep = currentStep > state.visitedStep ? currentStep : state.visitedStep;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CRITERIA_CHANGED"], function (state, value) {
  state.criteriaChanged = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["RESET_SUBMODELS"], function (state) {
  state.isSubmodelSelected = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CORPORATE_ID"], function (state, id) {
  state.corporateId = id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CONFIGURATION"], function (state, data) {
  state.isLoading = false;
  state.scanproConfiguration = data;
  state.scanProChecklist = [];
  state.scanProCriteria = [];
  console.log('ScanPro Configuration', data);

  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (item.criteriaDetail !== null) {
          state.scanProCriteria.push({
            id: item.scanProId,
            value: item.criteriaDetail,
            selected: true,
            changed: false
          });
        } else {
          state.scanProChecklist.push({
            id: item.scanProId,
            value: item.scanProCriteria,
            selected: true,
            changed: false
          });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CHECKLIST"], function (state, data) {
  state.scanProChecklist = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CRITERIA"], function (state, data) {
  state.scanProCriteria = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_DECODED_VIN"], function (state, _ref) {
  var data = _ref.data,
      vin = _ref.vin;

  state.safety = null;
  state.decodedVin = null;
  state.isDecoded = false;
  state.submodels = [];
  state.isSubmodelSelected = false;
  state.vehicle = null;
  state.vin = vin;
  try {
    state.submodels.push({
      value: 0,
      name: ''
    });
    if (data.decoder_messages.decoder_errors.length === 0) {
      state.decodedVin = data;
      state.isDecoded = true;
      var styles = data.query_responses.Request_Result.us_market_data.us_styles;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(styles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var style = _step2.value;

          state.submodels.push({
            value: style.vehicle_id,
            name: style.name
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (e) {}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_VEHICLE"], function (state, id) {
  state.vehicle = null;
  state.safety = null;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.decodedVin.query_responses.Request_Result.us_market_data.us_styles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var style = _step3.value;

      if (style.vehicle_id === id) {
        state.vehicle = style;
        state.isSubmodelSelected = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  if (state.vehicle !== null) {}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_RECOMMENDATION"], function (state, data) {
  state.recommendation = data;
  state.safety = [];
  var idx = 0;
  if (data !== undefined && data !== null) {
    if (data.scanRecommendation !== undefined && data.scanRecommendation !== null) {
      if (data.scanRecommendation.safetyFeatures !== undefined && data.scanRecommendation.safetyFeatures !== null) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data.scanRecommendation.safetyFeatures), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            idx++;
            state.safety.push({
              id: idx,
              name: item
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    }
  }
  console.log('Eval Recommendation', { recommendation: state.recommendation, safety: state.safety });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SELECTED_CHECKLIST_ITEMS"], function (state, data) {
  state.selectedChecklistItems = data;
}), _types$SET_STEP$types);

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    step: 1,
    visitedStep: 1,
    scanproConfiguration: null,
    scanProChecklist: [],
    scanProCriteria: [],
    criteriaChanged: false,
    isDecoded: false,
    vin: '',
    decodedVin: null,
    isSubmodelSelected: false,
    submodels: [],
    vehicle: null,
    recommendation: null,
    safety: null,
    selectedChecklistItems: [],
    isLoading: false,
    corporateId: 49
  };
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(154);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  getServiceRequests: function getServiceRequests(_ref7, searchOptions) {
    var _this = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequests(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUESTS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  backDateServiceRequest: function backDateServiceRequest(_ref8, workOrder) {
    var _this2 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].backDateServiceRequest(workOrder).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getServiceRequestsForList: function getServiceRequestsForList(_ref9, searchOptions) {
    var _this3 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestsForList(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUESTS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getServiceRequest: function getServiceRequest(_ref10, id) {
    var _this4 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequest(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getServiceRequestHistory: function getServiceRequestHistory(_ref11, id) {
    var _this5 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestHistory(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST_HISTORY"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getServiceRequestIssues: function getServiceRequestIssues(_ref12, id) {
    var _this6 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestIssues(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST_ISSUES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  serviceRequest: function serviceRequest(state) {
    return state.serviceRequest;
  },
  serviceRequests: function serviceRequests(state) {
    return state.serviceRequests;
  },
  requestHistory: function requestHistory(state) {
    return state.requestHistory;
  },
  issues: function issues(state) {
    return state.issues;
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(154);


var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST"], function (state, data) {
  state.serviceRequest = null;
  if (data !== undefined && data !== null) {
    if (Array.isArray(data)) {
      state.serviceRequest = data[0];
    } else {
      state.serviceRequest = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUESTS"], function (state, data) {
  state.serviceRequests = { count: 0, items: [] };
  if (data !== undefined && data !== null) {
    if (data.count === null) {
      data.count = 0;
    }
    if (data.items === null) {
      data.items = [];
    }
    state.serviceRequests = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST_HISTORY"], function (state, data) {
  state.requestHistory = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST_ISSUES"], function (state, data) {
  state.issues = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.issues = data;
    }
  }
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    serviceRequest: null,
    serviceRequests: [],
    requestHistory: [],
    searchTerm: '',
    pageSize: 10,
    sortDir: 'desc',
    orderBy: 'Id',
    status: '',
    filterBy: 0,
    issues: []
  };
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  setTranslation: function setTranslation(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('SET_TRANSLATION', data);
  },
  setServiceElementTranslation: function setServiceElementTranslation(_ref2, data) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit('SET_SERVICE_ELEMENT_TRANSLATION', data);
  },
  translateAllReportSections: function translateAllReportSections(_ref3, code) {
    var _this = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.translations = [];
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].translateAllReportSections(code).then(function (response) {
                  commit('SET_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getReportTranslations: function getReportTranslations(_ref4, data) {
    var _this2 = this;

    var commit = _ref4.commit,
        state = _ref4.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.translations = [];
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getReportTranslations(data).then(function (response) {
                  commit('SET_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveTranslations: function saveTranslations(_ref5, data) {
    var _this3 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTranslations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  translateAllServiceElements: function translateAllServiceElements(_ref6, cultureCode) {
    var _this4 = this;

    var commit = _ref6.commit,
        state = _ref6.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state.serviceElementTranslations = [];
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].translateAllServiceElements(cultureCode).then(function (response) {
                  commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getServiceElementTranslations: function getServiceElementTranslations(_ref7, data) {
    var _this5 = this;

    var commit = _ref7.commit,
        state = _ref7.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.serviceElementTranslations = [];
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceElementTranslations(data).then(function (response) {
                  commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  saveServiceElementTranslations: function saveServiceElementTranslations(_ref8, data) {
    var _this6 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveServiceElementTranslations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  localeTranslation: function localeTranslation(_ref9, data) {
    var _this7 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].localeTranslation(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  translations: function translations(state) {
    return state.translations;
  },
  serviceElementTranslations: function serviceElementTranslations(state) {
    return state.serviceElementTranslations;
  },
  languages: function languages(state) {
    return state.languages;
  }
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(309);



var _types$SET_TRANSLATIO;


/* harmony default export */ __webpack_exports__["default"] = (_types$SET_TRANSLATIO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TRANSLATIONS"], function (state, translations) {
  state.translations = translations;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.translations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      item.isTranslated = false;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SERVICE_ELEMENT_TRANSLATIONS"], function (state, translations) {
  state.serviceElementTranslations = translations;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.serviceElementTranslations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      item.isTranslated = false;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TRANSLATION"], function (state, data) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.translations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var item = _step3.value;

      if (item.applyTo === data.applyTo && item.name === data.name) {
        item.translation = data.translation;
        item.isTranslated = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SERVICE_ELEMENT_TRANSLATION"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.serviceElementTranslations), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.serviceElementId === data.serviceElementId) {
        item.translation = data.translation;
        item.isTranslated = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$SET_TRANSLATIO);

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    translations: [],
    serviceElementTranslations: [],
    languages: []
  };
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TRANSLATIONS", function() { return SET_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_ELEMENT_TRANSLATIONS", function() { return SET_SERVICE_ELEMENT_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TRANSLATION", function() { return SET_TRANSLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_ELEMENT_TRANSLATION", function() { return SET_SERVICE_ELEMENT_TRANSLATION; });
var SET_TRANSLATIONS = 'SET_TRANSLATIONS';
var SET_SERVICE_ELEMENT_TRANSLATIONS = 'SET_SERVICE_ELEMENT_TRANSLATIONS';
var SET_TRANSLATION = 'SET_TRANSLATION';
var SET_SERVICE_ELEMENT_TRANSLATION = 'SET_SERVICE_ELEMENT_TRANSLATION';

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(155);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  initUser: function initUser(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["INIT_USER"]);
  },
  highlightSave: function highlightSave(_ref8, value) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT"], value);
  },
  highlightPasswordSave: function highlightPasswordSave(_ref9, value) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT_PASSWORD"], value);
  },
  setUserRole: function setUserRole(_ref10, value) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER_ROLE"], value);
  },
  setSource: function setSource(_ref11, source) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SOURCE"], source);
  },
  getUser: function getUser(_ref12, username) {
    var _this = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUser(username).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getUsers: function getUsers(_ref13, searchOptions) {
    var _this2 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUsers(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USERS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadAllUsers: function downloadAllUsers(_ref14) {
    var _this3 = this;

    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadAllUsers().then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  updateUser: function updateUser(_ref15) {
    var _this4 = this;

    var commit = _ref15.commit,
        state = _ref15.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var data = {
                  Id: state.user.UserId,
                  Roles: state.user.Roles,
                  FamilyName: state.user.LastName,
                  GivenName: state.user.FirstName,
                  Username: state.user.Username,
                  Email: state.user.Email,
                  DispatchGroupEmail: state.user.DispatchGroupEmail,
                  IsActive: state.user.IsActive,
                  IsLockedOut: state.user.IsLockedOut,
                  RootLocationId: state.user.LocationId,
                  IsMahle: state.user.IsMahle
                };
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateUser(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  createUser: function createUser(_ref16, data) {
    var _this5 = this;

    var commit = _ref16.commit,
        state = _ref16.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var user = {
                  CreatedBy: data.CreatedBy,
                  Roles: state.user.Roles,
                  FamilyName: state.user.LastName,
                  GivenName: state.user.FirstName,
                  Username: state.user.Username,
                  Email: state.user.Email,
                  DispatchGroupEmail: state.user.DispatchGroupEmail,
                  Password: state.user.Password,
                  IsActive: state.user.IsActive,
                  IsLockedOut: state.user.IsLockedOut,
                  RootLocationId: data.LocationId,
                  IsMahle: data.IsMahle
                };
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].createUser(user).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  resetUserPassword: function resetUserPassword(_ref17, user) {
    var commit = _ref17.commit,
        state = _ref17.state;

    if (user.password === null) {
      alert('Password must be provided.');
      return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('User Password Reset', user);
      var data = {
        password: user.Password,
        resetLockout: !user.IsLockedOut,
        id: user.UserId
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].resetUserPassword(data).then(function (response) {
        alert('Password has been reset successfully!');
        resolve(response);
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT_PASSWORD"], false);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  checkEmailExists: function checkEmailExists(_ref18) {
    var _this6 = this;

    var commit = _ref18.commit,
        state = _ref18.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              result = false;

              console.log('test email', state.user.UserId, state.user.Email);
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].checkEmailExists(state.user.UserId, state.user.Email).then(function (response) {
                  console.log('checked email', response);
                  resolve(response);
                  result = response.data;
                  return result;
                });
              }));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  user: function user(state) {
    return state.user;
  },
  users: function users(state) {
    return state.users;
  },
  totalUsers: function totalUsers(state) {
    return state.totalUsers;
  },
  currentUser: function currentUser(state) {
    return state.currentUser;
  },
  highlight: function highlight(state) {
    return state.highlight;
  },
  highlightPassword: function highlightPassword(state) {
    return state.highlightPassword;
  },
  source: function source(state) {
    return state.source;
  }
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(155);




var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["INIT_USER"], function (state) {
  state.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.default));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_HIGHLIGHT"], function (state, value) {
  state.highlight = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_HIGHLIGHT_PASSWORD"], function (state, value) {
  state.highlightPassword = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_ROLE"], function (state, role) {
  state.user.Role = role.name;
  state.user.Roles = [];
  state.user.Roles.push({
    Name: role.name,
    Id: role.id
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SOURCE"], function (state, source) {
  state.source = source;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], function (state, data) {
  state.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.default));
  if (data.length > 0) {
    state.user = data[0];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USERS"], function (state, data) {
  state.totalUsers = 0;
  state.users = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalUsers = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.users = data;
    }
  }
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    default: {
      BusinessName: '',
      Email: '',
      DispatchGroupEmail: '',
      FirstName: '',
      IsUK: 0,
      LastName: '',
      Location: {
        Id: 0,
        Name: ''
      },
      LocationId: 0,
      PartnerId: null,
      Role: '',
      Roles: [{
        Id: 0,
        Name: ''
      }],
      TimeZone: '',
      UserId: 0,
      Username: '',
      IsActive: true,
      IsLockedOut: false,
      Password: ''
    },
    user: null,
    users: [],
    totalUsers: 0,
    currentUser: null,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Name',
    status: '',
    filterBy: 0,
    highlight: false,
    highlightPassword: false,
    source: null
  };
});

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currency__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dates__ = __webpack_require__(614);



/* harmony default export */ __webpack_exports__["a"] = ({
  currency: __WEBPACK_IMPORTED_MODULE_0__currency__,
  dates: __WEBPACK_IMPORTED_MODULE_1__dates__
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1010);



var language = 'en';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocales() {
  var locales = __webpack_require__(1017);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: language,
  fallbackLocale: 'en',
  messages: loadLocales()
}));

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var errorHandler = function errorHandler(err, vm, info) {
  console.error(err);
  console.error(vm);
  console.error(info);
};

/* harmony default export */ __webpack_exports__["a"] = (errorHandler);

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var Component = __webpack_require__(567)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1011),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);


var appName = 'athena';
var environment = window.config ? window.config.environment : 'local';

var hash = function hash(key) {
  return __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash('md5').update(appName + '/' + environment + '/' + key).digest('hex');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  session: {
    setItem: function setItem(key, value) {
      sessionStorage.setItem(hash(key), value);
    },
    getItem: function getItem(key) {
      return sessionStorage.getItem(hash(key));
    },
    clear: function clear() {
      sessionStorage.clear();
    }
  },
  local: {
    setItem: function setItem(key, value) {
      localStorage.setItem(hash(key), value);
    },
    getItem: function getItem(key) {
      return localStorage.getItem(hash(key));
    },
    clear: function clear() {
      localStorage.clear();
    }
  }
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  upsertBusiness: function upsertBusiness(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/Upsert', data);
  },
  upsertBusinessUser: function upsertBusinessUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/ModifyUsers', data);
  },
  upsertBusinessNote: function upsertBusinessNote(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertNote', data);
  },
  upsertBusinessDocument: function upsertBusinessDocument(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/AddDocument', data, config);
  },
  upsertBusinessInfo: function upsertBusinessInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertInfo', data);
  },
  upsertBusinessPromotion: function upsertBusinessPromotion(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertPromotion', data);
  },
  upsertBusinessBilling: function upsertBusinessBilling(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertBilling', data);
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertDiscount', data);
  },
  upsertDiscountProductAdd: function upsertDiscountProductAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertDiscountProductAdd', data);
  },
  swapShop: function swapShop(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('saintgobain/swapshopid', data);
  },
  setBusinessStatus: function setBusinessStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/SetBusinessStatus', data);
  },
  resetUserPassword: function resetUserPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('User/ResetPassword', data);
  },
  getDownloadToken: function getDownloadToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('User/GetDownloadToken', data);
  },
  getBusinesses: function getBusinesses(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Registered', data);
  },
  getBusinessLocation: function getBusinessLocation(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Location?key=' + sid);
  },
  getBusinessInfo: function getBusinessInfo(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Info?key=' + sid);
  },
  getBusinessPromotion: function getBusinessPromotion(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Promotion?key=' + sid);
  },
  getBusinessUsers: function getBusinessUsers(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Users?key=' + sid);
  },
  getBusinessNotes: function getBusinessNotes(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Notes?key=' + sid);
  },
  getBusinessBilling: function getBusinessBilling(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Billing?key=' + sid);
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref) {
    var sid = _ref.sid,
        type = _ref.type,
        other = _ref.other;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Discounts?key=' + sid + '&type=' + type + '&other=' + other);
  },
  getBusinessDiscountsProductAdds: function getBusinessDiscountsProductAdds(_ref2) {
    var sid = _ref2.sid;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/DiscountsProductAdds?key=' + sid);
  },
  lookupBusiness: function lookupBusiness(search) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('business/LookupBusiness?search=' + search);
  },
  getRoles: function getRoles(type) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Roles?type=' + type);
  },
  searchBusinesses: function searchBusinesses(search) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Search', {
      params: search
    });
  }
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  authUser: function authUser(credentials, callback, error) {
    __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].auth(credentials, callback, error);
  },
  getUserInfo: function getUserInfo(username) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/getUserByName?username=' + username);
  }
});

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationRecommendations: function getCalibrationRecommendations(make) {
    if (make !== undefined && make !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendations?vehicleMake=' + make);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendations');
    }
  },
  getCalibrationRecommendation: function getCalibrationRecommendation(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendation?id=' + id);
  },
  saveCalibrationRecommendations: function saveCalibrationRecommendations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('calibrate/saveCalibrationRecommendations', data);
  },
  deleteCalibrationRecommendation: function deleteCalibrationRecommendation(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/deleteCalibrationRecommendation?id=' + id);
  }
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationHomepageMessage: function getCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('NotificationMessage/GetWelcomeNotificationMessage');
  },
  getTranslatedCalibrationHomepageMessage: function getTranslatedCalibrationHomepageMessage(languageCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('NotificationMessage/GetTranslatedCalibrationWelcomeMessage?languageCode=' + languageCode);
  },
  saveCalibrationHomepageMessage: function saveCalibrationHomepageMessage(message) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/SaveCalibrationWelcomeMessage', message);
  },
  enableCalibrationHomepageMessage: function enableCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/EnableCalibrationWelcomeMessage');
  },
  disableCalibrationHomepageMessage: function disableCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/DisableCalibrationWelcomeMessage');
  }
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getChannels: function getChannels(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdGroupChannels?token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search) + '&includeMembers=1&chatChannelType=' + options.channelType);
  },
  getChatUsers: function getChatUsers(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdUsers?token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search));
  },
  getChatUserChannels: function getChatUserChannels(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdUserChannels?userid=' + options.userid + '&token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search));
  },
  removeChannels: function removeChannels(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/RemoveGroupChannel', data);
  },
  removeUsers: function removeUsers(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/RemoveUser', data);
  },
  saveMessage: function saveMessage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('message/InsertUserMessage', data);
  },
  saveTranslatedMessage: function saveTranslatedMessage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('message/AddMessageTranslated', data);
  },
  getChatHistory: function getChatHistory(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('Message/ServiceRequestMessages?id=' + id + '&language=en');
  },
  saveChatMessages: function saveChatMessages(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/SaveChatHistoryWait', data);
  }
});

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getAllCountries: function getAllCountries() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('countrystate/GetCountryList');
  },
  getStateProvinces: function getStateProvinces(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('countrystate/GetStateProvinceList?id=' + id);
  },
  upsertCountry: function upsertCountry(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/UpsertCountry', data);
  },
  upsertStateProvince: function upsertStateProvince(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/UpsertStateProvince', data);
  },
  deleteStateProvince: function deleteStateProvince(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/DeleteStateProvince', data);
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getDataSchema: function getDataSchema(name) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardDataSchema?name=' + name);
  },
  getChoices: function getChoices(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardSummaryChoices?startDate=' + data.startDate + '&endDate=' + data.endDate + '&category=' + data.category);
  },
  downloadRequestStatistics: function downloadRequestStatistics(data) {
    console.log('Download Request Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportServiceRequestStatistics', data);
  },
  downloadDeviceStatistics: function downloadDeviceStatistics(data) {
    console.log('Download Device Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportDeviceStatistics', data);
  },
  downloadActivationCardStatistics: function downloadActivationCardStatistics(data) {
    console.log('Download Activation Card Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportActivationCardStatistics', data);
  },
  downloadBusinessAccountInfo: function downloadBusinessAccountInfo(data) {
    console.log('Download Business Accounts Informations', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportBusinessAccountSetup', data);
  },
  downloadDeviceShipments: function downloadDeviceShipments(data) {
    console.log('Download Device Shipments', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportDeviceShipment', data);
  },
  downloadRequests: function downloadRequests(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/ExportServiceRequests?startDate=' + data.startDate + '&endDate=' + data.endDate);
  },
  downloadRequestsAdhoc: function downloadRequestsAdhoc(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportServiceRequestsAdhoc', data);
  },
  getQueryTemplates: function getQueryTemplates() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardDataTemplates');
  },
  saveQueryTemplate: function saveQueryTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/DashboardDataTemplateSave', data);
  },
  removeQueryTemplate: function removeQueryTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/DashboardDataTemplateRemove', data);
  }
});

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getDevice: function getDevice(serialNumber) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetDevice?serialNumber=' + serialNumber);
  },
  getDeviceById: function getDeviceById(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetDeviceById?id=' + id);
  },
  getDevices: function getDevices(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetDevicesForListing', {
      params: searchOptions
    });
  },
  downloadAllTools: function downloadAllTools(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetAllTools?id=' + id);
  },
  getTools: function getTools(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetToolsForListing', {
      params: searchOptions
    });
  },
  getdevicefiles: function getdevicefiles(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetAllDeviceFiles', {
      params: searchOptions
    });
  },
  getDeviceFileById: function getDeviceFileById(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetDeviceFileById?id=' + id);
  },
  getToolMakes: function getToolMakes(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetToolMakes?id=' + id);
  },
  createDevice: function createDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/CreateDevice', data);
  },
  activateDevice: function activateDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('smartlink/activateDevice', data);
  },
  getDeviceActivation: function getDeviceActivation(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('smartlink/DeviceActivatationInfo', data);
  },
  updateDevice: function updateDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/UpdateDevice', data);
  },
  updateDeviceFile: function updateDeviceFile(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/UpdateDeviceFile', data);
  },
  upsertDeviceShipment: function upsertDeviceShipment(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/UpsertDeviceShipment', data);
  },
  addToolMake: function addToolMake(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/AddToolMake', data);
  },
  deleteToolMake: function deleteToolMake(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/DeleteToolMake?id=' + id);
  },
  assignDevice: function assignDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('device/AssignDevice', data);
  }
});

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getFiles: function getFiles(path) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/list?folder=' + path);
  },
  getBase64File: function getBase64File(file) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/fileBase64?file=' + file);
  },
  getThumbs: function getThumbs(path) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/thumbsBase64?path=' + path);
  },
  uploadBase64File: function uploadBase64File(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('file/uploadBase64', data);
  }
});

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  lookup: function lookup(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKey', data, config);
  },
  lookups: function lookups(keys, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKeys', keys, config);
  },
  lookupsZeus: function lookupsZeus(key) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetLookupValues?key=' + key);
  },
  lookupsByGroup: function lookupsByGroup(_ref) {
    var className = _ref.className,
        group = _ref.group;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ByGroup?className=' + className + '&group=' + group);
  },
  serverProfiles: function serverProfiles() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetServerProfiles');
  },
  scanTypes: function scanTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetScanTypes');
  },
  upsertScanType: function upsertScanType(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/UpsertScanType', data);
  },
  activationCards: function activationCards() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetActivationCards');
  },
  releaseTracks: function releaseTracks() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetReleaseTracks');
  },
  hardwares: function hardwares() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetHardwares');
  },
  upsertActivationCard: function upsertActivationCard(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/UpsertActivationCard', data);
  },
  upsertLookup: function upsertLookup(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/Upsert', data);
  },
  upsertLookupZeus: function upsertLookupZeus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveZeusLookup', data);
  },
  upsertProduct: function upsertProduct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProduct', data);
  },
  getTimeZones: function getTimeZones() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/TimeZones');
  },
  getDistributors: function getDistributors() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Distributors');
  },
  getSalesReps: function getSalesReps() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/SalesReps');
  },
  getVehicleManufacturers: function getVehicleManufacturers() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/VehicleManufacturers');
  },
  getInsuranceCompanies: function getInsuranceCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/InsuranceCompanies');
  },
  getProducts: function getProducts() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Products');
  },
  getStates: function getStates(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/StateProvince?id=' + id);
  },
  getCountries: function getCountries() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Countries');
  },
  getLanguages: function getLanguages() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Languages');
  },
  savePreCannedMessages: function savePreCannedMessages(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SavePrecannedMessages', data, config);
  },
  getVehicleMakes: function getVehicleMakes(year) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/VehicleMakes/?year=' + year);
  },
  getProductAdds: function getProductAdds() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ProductAdds');
  },
  upsertProductAdd: function upsertProductAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProductAdd', data);
  },
  getMakes: function getMakes(showAll) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetMakes?showAll=' + showAll);
  },
  saveMakes: function saveMakes(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveMakes', data, config);
  },
  getProductMakes: function getProductMakes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ProductMakes');
  },
  getLaunchAccountList: function getLaunchAccountList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('smartlink/GetLaunchAccountList');
  },
  upsertProductMake: function upsertProductMake(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProductMake', data);
  },
  getRagRatingList: function getRagRatingList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RagRatingList');
  },
  getDeviceManufactureModels: function getDeviceManufactureModels() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetDeviceManufactureAndModels');
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  addInsurance: function addInsurance(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/SaveInsurance?name=' + data);
  },
  getWorkOrderMaintenance: function getWorkOrderMaintenance(workOrder) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/GetWorkOrder', {
      params: { workOrder: workOrder }
    });
  },
  saveWorkOrderMaintenance: function saveWorkOrderMaintenance(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('maintenance/SaveWorkOrder', data);
  },
  fixDispatchTimes: function fixDispatchTimes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/FixDispatchTimes');
  },
  cancelPendingRequests: function cancelPendingRequests(location) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/CancelPendingRequests', {
      params: { location: location }
    });
  },
  searchTechnicians: function searchTechnicians(searchTerm) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/SearchTechnicians/?search=' + searchTerm);
  },
  resetTechnician: function resetTechnician(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('maintenance/ResetTechnician', data);
  }
});

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getStandardOpeningHours: function getStandardOpeningHours(tenantId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/GetStandardOpeningHours?tenantId=' + tenantId);
  },
  getHolidayOpeningHours: function getHolidayOpeningHours(tenantId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/GetHolidayOpeningHours?tenantId=' + tenantId);
  },
  getStandardOpeningHoursForList: function getStandardOpeningHoursForList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/StandardOpeningHoursForList');
  },
  getStandardOpeningHoursForId: function getStandardOpeningHoursForId(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/StandardOpeningHoursForId?id=' + id);
  },
  getHolidayOpeningHoursForId: function getHolidayOpeningHoursForId(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/HolidayOpeningHoursForId?id=' + id);
  },
  getTenantDetails: function getTenantDetails() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/TenantDetails');
  },
  updateStandardOpeningHours: function updateStandardOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateStandardOpeningHours', data);
  },
  updateHolidayOpeningHours: function updateHolidayOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateHolidayOpeningHours', data);
  },
  insertHolidayOpeningHours: function insertHolidayOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/InsertHolidayOpeningHours', data);
  },
  deleteHolidaySchedule: function deleteHolidaySchedule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/DeleteHolidayOpeningHours', data);
  },
  updateTenantSupportEmail: function updateTenantSupportEmail(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateTenantSupportEmail', data);
  },
  getOutOfHoursAuditLog: function getOutOfHoursAuditLog(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/GetAuditLog', searchOptions);
  }
});

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getScanTools: function getScanTools() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetScanTools');
  },
  saveScanTool: function saveScanTool(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveScanTool', data);
  },
  removeScanTool: function removeScanTool(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RemoveScanTool?id=' + id);
  },
  getReportTemplates: function getReportTemplates(area) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetReportTemplates?area=' + area);
  },
  saveReportTemplate: function saveReportTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveReportTemplate', data);
  },
  removeReportTemplate: function removeReportTemplate(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RemoveReportTemplate?id=' + id);
  }
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  saveScanProConfiguration: function saveScanProConfiguration(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/SaveScanProConfiguration', data);
  },
  getScanProConfiguration: function getScanProConfiguration(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('scanpro/ScanProConfiguration?id=' + id);
  },
  decodeVin: function decodeVin(vin) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('decoder/DecodeVin?vin=' + vin);
  },
  evaluateVehicle: function evaluateVehicle(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/EvaluateVehicle', data);
  },
  saveScanProResults: function saveScanProResults(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/SaveScanProResults', data);
  }
});

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  serviceElements: function serviceElements() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetServiceElementList');
  },
  upsertServiceElement: function upsertServiceElement(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/UpsertServiceElement', data);
  },
  getServiceElementGroups: function getServiceElementGroups() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetServiceElementGroups');
  },
  getDistinctVehicleMakes: function getDistinctVehicleMakes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetVehicleMakes');
  },
  getDistinctVehicleModels: function getDistinctVehicleModels(_ref) {
    var make = _ref.make,
        year = _ref.year;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetVehicleModels?make=' + make + '&year=' + year);
  },
  getServiceElementsRagRating: function getServiceElementsRagRating(_ref2) {
    var make = _ref2.make,
        model = _ref2.model,
        year = _ref2.year,
        orderBy = _ref2.orderBy,
        sortBy = _ref2.sortBy;

    var encodedMake = encodeURIComponent(make || '');
    var encodedModel = encodeURIComponent(model || '');
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetServiceElementsRagRating?make=' + encodedMake + '&model=' + encodedModel + '&year=' + year + '&orderBy=' + orderBy + '&sortBy=' + sortBy);
  },
  getVehicleRagRatingId: function getVehicleRagRatingId(_ref3) {
    var make = _ref3.make,
        model = _ref3.model,
        year = _ref3.year;

    var encodedMake = encodeURIComponent(make || '');
    var encodedModel = encodeURIComponent(model || '');
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetRAGRatingVehicleId?make=' + encodedMake + '&model=' + encodedModel + '&year=' + year);
  },
  updateRagRating: function updateRagRating(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/UpdateRagRatingForServiceElement', data);
  },
  bulkCopyRagRating: function bulkCopyRagRating(_ref4) {
    var bulkCopyParams = _ref4.bulkCopyParams;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/BulkCopyRagRatings', bulkCopyParams);
  },
  copyRagRating: function copyRagRating(_ref5) {
    var sourceVehicleId = _ref5.sourceVehicleId,
        targetVehicleId = _ref5.targetVehicleId;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/CopyRagRatings?sourceVehicleId=' + sourceVehicleId + '&targetVehicleId=' + targetVehicleId);
  },
  audit: function audit(_ref6) {
    var auditDetails = _ref6.auditDetails;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/Audit', auditDetails);
  },
  getRagAuditTypeList: function getRagAuditTypeList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetAuditTypeList');
  },
  getAuditLog: function getAuditLog(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/GetAuditLog', searchOptions);
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getServiceRequests: function getServiceRequests(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/GetServiceRequests', {
      params: searchOptions
    });
  },
  backDateServiceRequest: function backDateServiceRequest(workOrder) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/AdjustWorkOrderCreatedDate?workOrderId=' + workOrder);
  },
  getServiceRequestsWithMessages: function getServiceRequestsWithMessages(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    });
  },
  getServiceRequestsForList: function getServiceRequestsForList(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    });
  },
  getServiceRequest: function getServiceRequest(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequest?id=' + id);
  },
  getServiceRequestHistory: function getServiceRequestHistory(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/GetServiceRequestHistory?id=' + id);
  },
  getServiceRequestIssues: function getServiceRequestIssues(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('issue/GetIssues?&status=ByRequest&searchTerm=' + id);
  }
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getReportTranslations: function getReportTranslations(code) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetReportTranslations?code=' + code);
  },
  saveTranslations: function saveTranslations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveReportTranslations', data);
  },
  translateAllReportSections: function translateAllReportSections(code) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/TranslateAllReportSections?code=' + code);
  },
  getServiceElementTranslations: function getServiceElementTranslations(cultureCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetServiceElementTranslations?cultureCode=' + cultureCode);
  },
  saveServiceElementTranslations: function saveServiceElementTranslations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveServiceElementTranslations', data);
  },
  translateAllServiceElements: function translateAllServiceElements(cultureCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/TranslateAllServiceElements?cultureCode=' + cultureCode);
  },
  localeTranslation: function localeTranslation(data) {
    console.log('API Locale Translation', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/AppLabelTranslations', data);
  }
});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["default"] = ({
  getUser: function getUser(username) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetUserByName?username=' + username);
  },
  getUsers: function getUsers(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetUsers', {
      params: searchOptions
    });
  },
  downloadAllUsers: function downloadAllUsers() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetAllUsers');
  },
  createUser: function createUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/CreateUser', data);
  },
  updateUser: function updateUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/UpdateUser', data);
  },
  checkEmailExists: function checkEmailExists(id, email) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/EmailExists?userID=' + id + '&email=' + email);
  }
});

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["currencyUSD"] = currencyUSD;
var digitsRE = /(\d{3})(?=\d)/g;

function currencyUSD(value, currency, decimals) {
  var originalValue = value;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return originalValue;
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["shortDate"] = shortDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function shortDate(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MM/DD/YYYY hh:mm:ssa');
}

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logger__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_mask__ = __webpack_require__(564);














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.errorHandler = __WEBPACK_IMPORTED_MODULE_7__logger__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */]).forEach(function (filter) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter]).forEach(function (f) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(f, __WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter][f]);
  });
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_mask__["a" /* default */]);

window.app = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__locales__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__app___default.a);
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('ctk-tooltip', {
  bind: function bind(el, binding) {
    el.addEventListener('mouseenter', function () {
      var $tooltip = document.createElement('div');
      var $tooltipDimension = el.getBoundingClientRect();
      var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
      $tooltip.setAttribute('class', 'ctk-tooltip');
      $tooltip.setAttribute('id', 'CtkTooltip');
      $tooltip.innerHTML = binding.value;
      $tooltip.style.left = $tooltipDimension.left + $tooltipDimension.width / 2 + 'px';
      $tooltip.style.top = top - 30 + 'px';
      document.body.appendChild($tooltip);
    });
    el.addEventListener('mouseleave', function () {
      var elemToRemove = document.getElementById('CtkTooltip');
      elemToRemove.parentNode.removeChild(elemToRemove);
    });
  }
});

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(94);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  console.log('Guard routing to ', to);
  if (to.path === '/login') {
    next();
    return;
  }
  console.log('checking anonymous...');

  if (to.matched.some(function (record) {
    return record.meta.allowAnonymous;
  })) {
    next();
    return;
  }
  console.log('checking login...');

  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/token']) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('authorize/setPassthrough', to.path);
    console.log('going to login');
    next('/login');
    return;
  }
  console.log('authorized');

  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/isAllowed'](to.path)) {
    console.log('not allowed...');
    next('/notauthorized');
    return;
  }
  console.log('allowed, continuing...');

  next();
});

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(94);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  redirect: function redirect(to) {
    var role = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/primaryRole'];
    console.log('Redirect Role', role);
    return 'business';
  },
  component: function component(resolve) {
    __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1068)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  children: [{
    path: 'notauthorized',
    component: function component(resolve) {
      __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1066)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },

    meta: { allowAnonymous: true }
  }, {
    path: 'login',
    component: function component(resolve) {
      __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },

    meta: { allowAnonymous: true }
  }, {
    path: 'business',
    component: function component(resolve) {
      __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1058)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'business/:action/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1057)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/requests',
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1063)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/statistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1064)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/devicestatistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1062)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/activationcardstatistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1059)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/businessaccountsinfo',
    component: function component(resolve) {
      __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1060)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/deviceshipments',
    component: function component(resolve) {
      __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'users',
    component: function component(resolve) {
      __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1069)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'users/:action/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1070)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/defaults',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1039)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/salesreps',
    component: function component(resolve) {
      __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1054)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/translation',
    component: function component(resolve) {
      __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1056)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/message',
    component: function component(resolve) {
      __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1047)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/devices',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1043)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-detail/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1040)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-file-detail/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1041)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-files',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1042)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/maintenance',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1045)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/report',
    component: function component(resolve) {
      __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1053)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/chat',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1038)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/calibrate',
    component: function component(resolve) {
      __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1036)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/mobile',
    component: function component(resolve) {
      __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1048)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/files',
    component: function component(resolve) {
      __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1044)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/scanpro',
    component: function component(resolve) {
      __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1055)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/makes',
    component: function component(resolve) {
      __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1046)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/calibration-homepage-message',
    component: function component(resolve) {
      __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1037)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/openinghours/opening-hours',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1050)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/openinghours/auditLog',
    component: function component(resolve) {
      __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1049)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/maintain-rag-ratings',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(573)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/auditLog',
    component: function component(resolve) {
      __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1051)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/maintenance',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(573)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/service-element-translation',
    component: function component(resolve) {
      __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1052)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: '*',
  component: function component(resolve) {
    __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1065)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  meta: { allowAnonymous: true }
}]);

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "admin", function() { return admin; });
var admin = {
  namespaced: true,
  state: {
    salesRepresentatives: []
  },
  getters: {
    salesRepresentatives: function salesRepresentatives(state) {
      return state.salesRepresentatives;
    }
  },
  actions: {},
  mutations: {
    ADD_SALES_REPRESENTATIVE: function ADD_SALES_REPRESENTATIVE(state, defaultTitleId) {
      state.salesRepresentatives.push({
        id: 0,
        firstName: null,
        lastName: null,
        hasLogin: false,
        username: null,
        email: null,
        password: null,
        requiresPasswordOnSubmit: false,
        isEnabled: false,
        isLockout: false,
        receivesInvoices: false,
        receivesReports: false,
        receivesReportsOnly: false,
        receivesChatReports: false,
        isAstechUser: false,
        titleId: defaultTitleId,
        phone: null
      });
    }
  }
};

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authorize", function() { return authorize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(241);





var authorize = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "business", function() { return business; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(245);





var business = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["default"],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calibrate", function() { return calibrate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(249);





var calibrate = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chat", function() { return chat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(254);





var chat = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configuration", function() { return configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_storage__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(256);






var configuration = {
  namespaced: true,
  state: {
    configuration: JSON.parse(__WEBPACK_IMPORTED_MODULE_3__plugins_storage__["a" /* default */].local.getItem(__WEBPACK_IMPORTED_MODULE_4__types__["CONFIGURATION"])) || []
  },
  getters: {
    configuration: function configuration(state) {
      return state.configuration;
    }
  },
  actions: {
    getConfigurationValues: function getConfigurationValues(_ref) {
      var commit = _ref.commit;

      var key = 'configuration';
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CONFIGURATION"], response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  },
  mutations: {
    SET_CONFIGURATION: function SET_CONFIGURATION(state, data) {
      __WEBPACK_IMPORTED_MODULE_3__plugins_storage__["a" /* default */].local.setItem(__WEBPACK_IMPORTED_MODULE_4__types__["CONFIGURATION"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    }
  }
};

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countries", function() { return countries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(12);




var countries = {
  namespaced: true,
  state: {
    countries: [],
    stateProvinces: []
  },
  getters: {
    countries: function countries(state) {
      return state.countries;
    },
    stateProvinces: function stateProvinces(state) {
      return state.stateProvinces;
    }
  },
  actions: {
    getAllCountries: function getAllCountries(_ref) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getAllCountries({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_COUNTRIES', JSON.parse(response.data));
          resolve(response);
        });
      });
    },
    getStateProvinces: function getStateProvinces(_ref2, id) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getStateProvinces(id).then(function (response) {
          commit('SET_STATE_PROVINCES', response.data);
          resolve(response);
        });
      });
    },
    resetStateProvinces: function resetStateProvinces(_ref3) {
      var commit = _ref3.commit;

      commit('SET_STATE_PROVINCES', null);
    },
    upsertCountry: function upsertCountry(_ref4, country) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertCountry(country).then(function (response) {
          country.id = response.data;
          if (response.status === 200) {
            commit('SET_COUNTRY', country);
          }
          resolve(response);
        });
      });
    },
    upsertStateProvince: function upsertStateProvince(_ref5, stateProvince) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertStateProvince(stateProvince).then(function (response) {
          stateProvince.id = response.data;
          if (response.status === 200) {
            commit('SET_STATE_PROVINCE', stateProvince);
          }
          resolve(response);
        });
      });
    },
    deleteStateProvince: function deleteStateProvince(_ref6, stateProvince) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteStateProvince(stateProvince).then(function (response) {
          resolve(response);
        });
      });
    }
  },
  mutations: {
    SET_COUNTRIES: function SET_COUNTRIES(state, data) {
      state.countries = data;
    },
    SET_COUNTRY: function SET_COUNTRY(state, data) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.id) === 'object' && data.id.error) {
        return;
      }

      var idx = state.countries.findIndex(function (i) {
        return i.id === data.id;
      });

      if (parseInt(idx) !== -1) {
        state.countries[idx].name = data.name;
        state.countries[idx].abbreviation = data.abbreviation;
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation
        };
        state.countries.push(lookup);
      }
    },
    SET_STATE_PROVINCES: function SET_STATE_PROVINCES(state, stateProvinces) {
      state.stateProvinces = stateProvinces || [];
    },
    SET_STATE_PROVINCE: function SET_STATE_PROVINCE(state, data) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.id) === 'object' && data.id.error) {
        return;
      }

      var idx = state.stateProvinces.findIndex(function (i) {
        return i.id === data.id;
      });

      if (parseInt(idx) !== -1) {
        state.stateProvinces[idx].name = data.name;
        state.stateProvinces[idx].abbreviation = data.abbreviation;
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation,
          countryId: data.countryId
        };
        state.stateProvinces.push(lookup);
      }
    }
  }
};

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dashboard", function() { return dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(259);





var dashboard = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "devices", function() { return devices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(263);





var devices = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "files", function() { return files; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(267);





var files = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locales", function() { return locales; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var defaultLang = __webpack_require__.i({"NODE_ENV":"production"}).defaultLang || window.localStorage.getItem('_lang') || window.app.defaultLang;

var locales = {
  state: {
    i18n_loaded: false,
    i18n_lang: defaultLang,
    i18n_allowedLang: [defaultLang] },
  getters: {
    i18n_lang: function i18n_lang(state) {
      return state.i18n_lang;
    },
    i18n_isValidLang: function i18n_isValidLang(state) {
      return function (lang) {
        return state.i18n_allowedLang.includes(lang);
      };
    },
    i18n_allowedLang: function i18n_allowedLang(state) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(state.i18n_allowedLang)));
    }
  },
  actions: {
    i18n_addAllowedLang: function i18n_addAllowedLang(_ref, lang) {
      var commit = _ref.commit;

      commit('SET_I18N_ALLOWED_LANG', lang);
    },
    i18n_setLang: function i18n_setLang(_ref2, lang) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (!state.i18n_allowedLang.includes(lang)) {
        lang = state.i18n_lang || defaultLang;
      }
      if (lang === state.i18n_lang && state.i18n_loaded) {
        return;
      }
      commit('SET_I18N_LANG', lang);
      commit('SET_I18N_LOADED', true);
    },
    i18n_changeLang: function i18n_changeLang(_ref3, lang) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var path = window.location.pathname.replace(state.i18n_lang, lang);
      console.log(window.location.replace(path));
    }
  },
  mutations: {
    SET_I18N_LANG: function SET_I18N_LANG(state, lang) {},
    SET_I18N_LOADED: function SET_I18N_LOADED(state, loaded) {
      state.i18n_loaded = loaded;
    },
    SET_I18N_ALLOWED_LANG: function SET_I18N_ALLOWED_LANG(state, lang) {
      state.i18n_allowedLang.push(lang);
    }
  }
};

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(12);





var lookup = {
  namespaced: true,
  state: {
    lookups: {},
    lookupsZeus: {},
    serverProfiles: [],
    timezones: [],
    states: [],
    countries: [],
    languages: [],
    products: [],
    insuranceCompanies: [],
    vehicleManufacturers: [],
    vehicleMakes: [],
    productAdds: [],
    productMakes: [],
    groups: [],
    invoiceMethods: [],
    taxRates: [],
    scanTypes: [],
    launchAccounts: [],
    serviceElementGroups: [],
    deviceManufactureModels: [],
    brands: [],
    activationTypes: [],
    activationCards: [],
    hardwares: [],
    releaseTracks: [],
    suppliers: []
  },
  getters: {
    lookups: function lookups(state) {
      return state.lookups;
    },
    lookupsZeus: function lookupsZeus(state) {
      return state.lookupsZeus;
    },
    serverProfiles: function serverProfiles(state) {
      return state.serverProfiles;
    },
    timezones: function timezones(state) {
      return state.timezones;
    },
    states: function states(state) {
      return state.states;
    },
    countries: function countries(state) {
      return state.countries;
    },
    languages: function languages(state) {
      return state.languages;
    },
    insuranceCompanies: function insuranceCompanies(state) {
      return state.insuranceCompanies;
    },
    vehicleManufacturers: function vehicleManufacturers(state) {
      return state.vehicleManufacturers;
    },
    products: function products(state) {
      return state.products;
    },
    vehicleMakes: function vehicleMakes(state) {
      return state.vehicleMakes;
    },
    productAdds: function productAdds(state) {
      return state.productAdds;
    },
    productMakes: function productMakes(state) {
      return state.productMakes;
    },
    groups: function groups(state) {
      return state.groups;
    },
    invoiceMethods: function invoiceMethods(state) {
      return state.invoiceMethods;
    },
    taxRates: function taxRates(state) {
      return state.taxRates;
    },
    scanTypes: function scanTypes(state) {
      return state.scanTypes;
    },
    launchAccounts: function launchAccounts(state) {
      return state.launchAccounts;
    },
    deviceManufactureModels: function deviceManufactureModels(state) {
      return state.deviceManufactureModels;
    },
    serviceElementGroups: function serviceElementGroups(state) {
      return state.serviceElementGroups;
    },
    brands: function brands(state) {
      return state.brands;
    },
    activationTypes: function activationTypes(state) {
      return state.activationTypes;
    },
    activationCards: function activationCards(state) {
      return state.activationCards;
    },
    releaseTracks: function releaseTracks(state) {
      return state.releaseTracks;
    },
    hardwares: function hardwares(state) {
      return state.hardwares;
    },
    suppliers: function suppliers(state) {
      return state.suppliers;
    }
  },
  actions: {
    getLookups: function getLookups(_ref, keys) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(keys, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS', { keys: keys, data: response.data });
          resolve(response);
        });
      });
    },
    getActivationTypes: function getActivationTypes(_ref2) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(['device.activationtypeid'], { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_ACTIVATIONTYPES', { data: response.data });
          resolve(response);
        });
      });
    },
    getSuppliers: function getSuppliers(_ref3) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(['device.supplierid'], { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SUPPLIERS', { data: response.data });
          resolve(response);
        });
      });
    },
    getLookupsZeus: function getLookupsZeus(_ref4, key) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS_ZEUS', { key: key, data: response.data });
          resolve(response);
        });
      });
    },
    getLookupsByGroup: function getLookupsByGroup(_ref5, _ref6) {
      var commit = _ref5.commit;
      var className = _ref6.className,
          group = _ref6.group;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookupsByGroup({ className: className, group: group }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_GROUPS', response.data);
          resolve(response);
        });
      });
    },
    getServerProfiles: function getServerProfiles(_ref7) {
      var commit = _ref7.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverProfiles().then(function (response) {
          commit('SET_SERVER_PROFILES', response.data);
          resolve(response);
        });
      });
    },
    getScanTypes: function getScanTypes(_ref8) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].scanTypes({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SCAN_TYPES', response.data);
          resolve(response);
        });
      });
    },
    getActivationCards: function getActivationCards(_ref9) {
      var commit = _ref9.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].activationCards({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_ACTIVATION_CARDS', response.data);
          resolve(response);
        });
      });
    },
    getReleaseTracks: function getReleaseTracks(_ref10) {
      var commit = _ref10.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].releaseTracks({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_RELEASETRACKS', response.data);
          resolve(response);
        });
      });
    },
    getHardwares: function getHardwares(_ref11) {
      var commit = _ref11.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].hardwares({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_HARDWARES', response.data);
          resolve(response);
        });
      });
    },
    getDeviceManufactureModels: function getDeviceManufactureModels(_ref12) {
      var commit = _ref12.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceManufactureModels({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_DEVICE_MANUFACTURE_MODELS', response.data);
          resolve(response);
        });
      });
    },
    upsertLookup: function upsertLookup(_ref13, lookup) {
      var commit = _ref13.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertLookup(lookup).then(function (response) {
          lookup.id = response.data;
          if (response.status === 200) {
            commit('SET_LOOKUP', lookup);
          }
          resolve(response);
        });
      });
    },
    upsertScanType: function upsertScanType(_ref14, scanType) {
      var commit = _ref14.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertScanType(scanType).then(function (response) {
          scanType.id = response.data;
          if (response.status === 200) {
            commit('SET_SCAN_TYPE', scanType);
          }
          resolve(response);
        });
      });
    },
    upsertActivationCard: function upsertActivationCard(_ref15, activationCard) {
      var commit = _ref15.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertActivationCard(activationCard).then(function (response) {
          activationCard.id = response.data;
          if (response.status === 200) {
            commit('SET_ACTIVATION_CARD', activationCard);
          }
          resolve(response);
        });
      });
    },
    upsertProduct: function upsertProduct(_ref16, product) {
      var commit = _ref16.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProduct(product).then(function (response) {
          product.id = response.data;
          product.hasDisclaimer = true;
          if (!product.disclaimer || product.disclaimer.length === 0) {
            product.hasDisclaimer = false;
          }
          if (response.status === 200) {
            commit('SET_PRODUCT', product);
          }
          resolve(response);
        });
      });
    },
    getTimeZones: function getTimeZones(_ref17) {
      var commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTimeZones().then(function (response) {
          commit('SET_TIMEZONES', response.data);
          resolve(response);
        });
      });
    },
    getStates: function getStates(_ref18, id) {
      var commit = _ref18.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStates(id).then(function (response) {
          commit('SET_STATES', response.data);
          resolve(response);
        });
      });
    },
    getCountries: function getCountries(_ref19) {
      var commit = _ref19.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCountries().then(function (response) {
          commit('SET_COUNTRIES', response.data);
          resolve(response);
        });
      });
    },
    getLanguages: function getLanguages(_ref20) {
      var commit = _ref20.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getLanguages().then(function (response) {
          commit('SET_LANGUAGES', response.data);
          resolve(response);
        });
      });
    },
    getInsuranceCompanies: function getInsuranceCompanies(_ref21) {
      var commit = _ref21.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getInsuranceCompanies().then(function (response) {
        if (response.status === 200) {
          commit('SET_INSURANCE_COMPANIES', response.data);
        }
      });
    },
    getVehicleManufacturers: function getVehicleManufacturers(_ref22) {
      var commit = _ref22.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getVehicleManufacturers().then(function (response) {
        if (response.status === 200) {
          commit('SET_VEHICLE_MANUFATURERS', response.data);
        }
      });
    },
    getProducts: function getProducts(_ref23) {
      var commit = _ref23.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProducts().then(function (response) {
          commit('SET_PRODUCTS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getLaunchAccountList: function getLaunchAccountList(_ref24) {
      var commit = _ref24.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getLaunchAccountList().then(function (response) {
          commit('SET_LAUNCH_ACCOUNTS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getVehicleMakes: function getVehicleMakes(_ref25, year) {
      var commit = _ref25.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getVehicleMakes(year).then(function (response) {
        if (response.status === 200) {
          commit('SET_VEHICLE_MAKES', response.data);
        }
      });
    },
    getProductAdds: function getProductAdds(_ref26) {
      var commit = _ref26.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProductAdds().then(function (response) {
          commit('SET_PRODUCTADDS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    upsertProductAdd: function upsertProductAdd(_ref27, productAdd) {
      var commit = _ref27.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProductAdd(productAdd).then(function (response) {
          productAdd.id = response.data;
          if (response.status === 200) {
            commit('SET_PRODUCTADD', productAdd);
          }
          resolve(response);
        });
      });
    },
    getProductMakes: function getProductMakes(_ref28) {
      var commit = _ref28.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProductMakes().then(function (response) {
          commit('SET_PRODUCTMAKES', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    upsertProductMake: function upsertProductMake(_ref29, productMake) {
      var commit = _ref29.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProductMake(productMake).then(function (response) {
          productMake.id = response.data;
          if (response.status === 200) {
            commit('SET_PRODUCTMAKE', productMake);
          }
          resolve(response);
        });
      });
    }
  },
  mutations: {
    SET_LOOKUPS: function SET_LOOKUPS(state, _ref30) {
      var keys = _ref30.keys,
          data = _ref30.data;

      if (data !== undefined && data !== null) {
        if ((typeof keys === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(keys)) === 'object') {
          if (data !== '') {
            keys.forEach(function (x) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, x, data.filter(function (l) {
                return l.key === x;
              }));
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, keys, data);
        }
      }
    },
    SET_LOOKUPS_ZEUS: function SET_LOOKUPS_ZEUS(state, _ref31) {
      var key = _ref31.key,
          data = _ref31.data;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookupsZeus, key, data);
    },
    SET_SERVER_PROFILES: function SET_SERVER_PROFILES(state, data) {
      state.serverProfiles = data;
    },
    SET_DEVICE_MANUFACTURE_MODELS: function SET_DEVICE_MANUFACTURE_MODELS(state, data) {
      state.deviceManufactureModels = data;
      var output = [];
      var keys = [];

      state.deviceManufactureModels.forEach(function (manufacture) {
        var key = manufacture.Brand;

        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(manufacture);
        }
      });
      console.log(output);
      state.brands = output;
      console.log(state.brands);
    },
    SET_SCAN_TYPES: function SET_SCAN_TYPES(state, data) {
      state.scanTypes = data;
      console.log(state.scanTypes);
    },
    SET_ACTIVATION_CARDS: function SET_ACTIVATION_CARDS(state, data) {
      console.log(data);
      state.activationCards = data;
      console.log('activationCards', state.activationCards);
    },
    SET_RELEASETRACKS: function SET_RELEASETRACKS(state, data) {
      console.log(data);
      state.releaseTracks = data;
      console.log('releaseTracks', state.releaseTracks);
    },
    SET_HARDWARES: function SET_HARDWARES(state, data) {
      console.log(data);
      state.hardwares = data;
      console.log('hardwares', state.hardwares);
    },
    SET_ACTIVATIONTYPES: function SET_ACTIVATIONTYPES(state, data) {
      state.activationTypes = data.data;
      console.log(state.activationTypes);
    },
    SET_SUPPLIERS: function SET_SUPPLIERS(state, data) {
      console.log(data);
      state.suppliers = data.data;
    },
    SET_SERVICE_ELEMENT_GROUPS: function SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data;
    },
    SET_SCAN_TYPE: function SET_SCAN_TYPE(state, data) {
      var idx = state.scanTypes.findIndex(function (i) {
        return i.id === data.id;
      });
      console.log(idx);
      if (idx !== -1) {
        if (data.isInActive) {
          state.scanTypes.splice(idx, 1);
        } else {
          state.scanTypes[idx].text = data.text;
          state.scanTypes[idx].serviceElementGroupId = data.serviceElementGroupId;
          state.scanTypes[idx].serviceElementGroupName = data.serviceElementGroupName;
        }
      } else {
        var _lookup = {
          id: data.id,
          key: 'workorder.servicetype',
          text: data.text,
          isActive: data.isInActive === false,
          value: data.value,
          dateValue: null,
          decimalValue: null,
          intValue: null,
          label: null,
          parentId: null,
          stringValue: null,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName
        };
        state.scanTypes.push(_lookup);
      }
    },
    SET_ACTIVATION_CARD: function SET_ACTIVATION_CARD(state, data) {
      var idx = state.activationCards.findIndex(function (i) {
        return i.id === data.id;
      });
      console.log(idx);
      if (idx !== -1) {
        state.activationCards[idx].activationCardId = data.activationCardId;
        state.activationCards[idx].activationPassword = data.activationPassword;
        state.activationCards[idx].assignedDate = data.assignedDate;
        state.activationCards[idx].assignedDeviceId = data.assignedDeviceId;
        state.activationCards[idx].activationAccountType = data.activationAccountType;
        state.activationCards[idx].activationAccountReference = data.activationAccountReference;
      } else {
        var activationCard = {
          id: data.id,
          activationCardId: data.activationCardId,
          activationPassword: data.activationPassword,
          activationAccountReference: data.activationAccountReference,
          activationAccountType: data.activationAccountType,
          assignedDate: null,
          assignedDeviceId: null,
          isActive: true
        };
        state.activationCards.push(activationCard);
      }
    },
    SET_LOOKUP: function SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup);
      } else {
        var index = state.lookups[lookup.key].findIndex(function (i) {
          return i.id === lookup.id;
        });
        state.lookups[lookup.key].splice(index, 1);
      }
    },
    SET_GROUPS: function SET_GROUPS(state, groups) {
      state.groups = [];
      if (groups !== undefined && groups !== null) {
        if (groups !== '') {
          state.groups = groups;
        }
      }
    },
    SET_TIMEZONES: function SET_TIMEZONES(state, timezones) {
      state.timezones = timezones || [];
    },
    SET_STATES: function SET_STATES(state, states) {
      state.states = states || [];
    },
    SET_COUNTRIES: function SET_COUNTRIES(state, countries) {
      state.countries = countries || [];
    },
    SET_LANGUAGES: function SET_LANGUAGES(state, languages) {
      state.languages = languages || [];
    },
    SET_LAUNCH_ACCOUNTS: function SET_LAUNCH_ACCOUNTS(state, launchAccounts) {
      console.log(launchAccounts.data);
      state.launchAccounts = launchAccounts.data || [];
    },
    SET_INSURANCE_COMPANIES: function SET_INSURANCE_COMPANIES(state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies || [];
    },
    SET_VEHICLE_MANUFATURERS: function SET_VEHICLE_MANUFATURERS(state, vehicleManufacturers) {
      state.vehicleManufacturers = vehicleManufacturers || [];
    },
    SET_PRODUCTS: function SET_PRODUCTS(state, products) {
      state.products = products || [];
      state.products.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCT: function SET_PRODUCT(state, product) {
      if (product.isActive) {
        if (product.id !== null && product.isAdd === false) {
          var idx = state.products.findIndex(function (i) {
            return i.id === product.id;
          });
          state.products[idx] = product;
        } else {
          state.products.push(product);
        }
      } else {
        var index = state.products.findIndex(function (i) {
          return i.id === product.id;
        });
        state.products.splice(index, 1);
      }
    },
    SET_VEHICLE_MAKES: function SET_VEHICLE_MAKES(state, vehicleMakes) {
      state.vehicleMakes = vehicleMakes || [];
    },
    SET_PRODUCTADDS: function SET_PRODUCTADDS(state, productAdds) {
      state.productAdds = productAdds || [];
      state.productAdds.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCTADD: function SET_PRODUCTADD(state, productAdd) {
      if (productAdd.isActive) {
        if (productAdd.id !== null && productAdd.isAdd === false) {
          var idx = state.productAdds.findIndex(function (i) {
            return i.id === productAdd.id;
          });
          state.productAdds[idx] = productAdd;
        } else {
          state.productAdds.push(productAdd);
        }
      } else {
        var index = state.productAdds.findIndex(function (i) {
          return i.id === productAdd.id;
        });
        state.productAdds.splice(index, 1);
      }
    },
    SET_PRODUCTMAKES: function SET_PRODUCTMAKES(state, productMakes) {
      state.productMakes = productMakes || [];
      state.productMakes.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCTMAKE: function SET_PRODUCTMAKE(state, productMake) {
      if (productMake.isActive) {
        if (productMake.id !== null && productMake.isAdd === false) {
          var idx = state.productMakes.findIndex(function (i) {
            return i.id === productMake.id;
          });
          state.productMakes[idx] = productMake;
        } else {
          state.productMakes.push(productMake);
        }
      } else {
        var index = state.productMakes.findIndex(function (i) {
          return i.id === productMake.id;
        });
        state.productMakes.splice(index, 1);
      }
    }
  }
};

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenance", function() { return maintenance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(272);





var maintenance = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "make", function() { return make; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(276);





var make = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "message", function() { return message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(281);





var message = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calibrationHomepageMessage", function() { return calibrationHomepageMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(286);





var calibrationHomepageMessage = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openinghours", function() { return openinghours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(290);





var openinghours = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "report", function() { return report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(294);





var report = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scanpro", function() { return scanpro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(299);





var scanpro = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serviceelements", function() { return serviceelements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(12);







var serviceelements = {
  namespaced: true,
  state: {
    lookups: {},
    pageSize: 10,
    totalLogEntries: 0,
    lookupsZeus: {},
    serviceElements: [],
    serviceElementGroups: [],
    makes: [],
    models: [],
    copyModels: [],
    serviceElementsRagRating: [],
    sortDir: '',
    orderBy: '',
    vehicleRagRatingId: '',
    ragAuditTypeList: [],
    ragAuditLog: []
  },
  getters: {
    pageSize: function pageSize(state) {
      return state.pageSize;
    },
    totalLogEntries: function totalLogEntries(state) {
      return state.totalLogEntries;
    },
    lookups: function lookups(state) {
      return state.lookups;
    },
    lookupsZeus: function lookupsZeus(state) {
      return state.lookupsZeus;
    },
    scanTypes: function scanTypes(state) {
      return state.scanTypes;
    },
    serviceElements: function serviceElements(state) {
      return state.serviceElements;
    },
    serviceElementGroups: function serviceElementGroups(state) {
      return state.serviceElementGroups;
    },
    makes: function makes(state) {
      return state.makes;
    },
    models: function models(state) {
      return state.models;
    },
    copyModels: function copyModels(state) {
      return state.copyModels;
    },
    serviceElementsRagRating: function serviceElementsRagRating(state) {
      return state.serviceElementsRagRating;
    },
    sortDir: function sortDir(state) {
      return state.sortDir;
    },
    orderBy: function orderBy(state) {
      return state.orderBy;
    },
    vehicleRagRatingId: function vehicleRagRatingId(state) {
      return state.vehicleRagRatingId;
    },
    ragAuditTypeList: function ragAuditTypeList(state) {
      return state.ragAuditTypeList;
    },
    ragAuditLog: function ragAuditLog(state) {
      return state.ragAuditLog;
    }
  },
  actions: {
    setPageSize: function setPageSize(_ref, pageSize) {
      var commit = _ref.commit;

      commit('SET_PAGE_SIZE', pageSize);
    },
    getLookups: function getLookups(_ref2, keys) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].lookups(keys, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS', { keys: keys, data: response.data });
          resolve(response);
        });
      });
    },
    getLookupsZeus: function getLookupsZeus(_ref3, key) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS_ZEUS', { key: key, data: response.data });
          resolve(response);
        });
      });
    },
    getServiceElements: function getServiceElements(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].serviceElements({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SERVICE_ELEMENTS', response.data);
          resolve(response);
        });
      });
    },
    getServiceElementGroups: function getServiceElementGroups(_ref5) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getServiceElementGroups({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SERVICE_ELEMENT_GROUPS', response.data);
          resolve(response);
        });
      });
    },
    getVehicleRagRatingId: function getVehicleRagRatingId(_ref6, _ref7) {
      var commit = _ref6.commit;
      var make = _ref7.make,
          model = _ref7.model,
          year = _ref7.year;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getVehicleRagRatingId({ make: make, model: model, year: year }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_VEHICLE_RAG_RATING_ID', response.data);
          resolve(response);
        });
      });
    },
    upsertServiceElement: function upsertServiceElement(_ref8, serviceElement) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].upsertServiceElement(serviceElement).then(function (response) {
          serviceElement.id = response.data;
          if (response.status === 200) {
            commit('SET_SERVICE_ELEMENT', serviceElement);
          }
          resolve(response);
        });
      });
    },
    getVehicleMakes: function getVehicleMakes(_ref9) {
      var commit = _ref9.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDistinctVehicleMakes({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_MAKES', response.data);
          resolve(response);
        });
      });
    },
    getVehicleModels: function getVehicleModels(_ref10, _ref11) {
      var commit = _ref10.commit;
      var make = _ref11.make,
          year = _ref11.year,
          isCopy = _ref11.isCopy;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDistinctVehicleModels({ make: make, year: year }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          if (isCopy) {
            commit('SET_COPY_MODELS', response.data);
          } else {
            commit('SET_MODELS', response.data);
          }
          resolve(response);
        });
      });
    },
    getServiceElementsRagRating: function getServiceElementsRagRating(_ref12, _ref13) {
      var commit = _ref12.commit;
      var make = _ref13.make,
          model = _ref13.model,
          year = _ref13.year,
          orderBy = _ref13.orderBy,
          sortBy = _ref13.sortBy;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getServiceElementsRagRating({ make: make, model: model, year: year, orderBy: orderBy, sortBy: sortBy }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SERVICE_ELEMENTS_RAG_RATING', response.data);
          resolve(response);
        });
      });
    },
    getAuditLog: function getAuditLog(_ref14, searchOptions) {
      var _this = this;

      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getAuditLog(searchOptions).then(function (response) {
                    commit('SET_RAG_AUDIT_LOG', response.data);
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRagAuditTypeList: function getRagAuditTypeList(_ref15) {
      var _this2 = this;

      var commit = _ref15.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getRagAuditTypeList().then(function (response) {
                    var newItem = { AuditTypeId: 0, AuditTypeName: 'All entries' };
                    response.data.unshift(newItem);
                    commit('SET_RAG_AUDIT_TYPE_LIST', response.data);
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateRagRating: function updateRagRating(_ref16, data) {
      var _this3 = this;

      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateRagRating(data).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    bulkCopyRagRating: function bulkCopyRagRating(_ref17, _ref18) {
      var _this4 = this;

      var commit = _ref17.commit,
          dispatch = _ref17.dispatch;
      var bulkCopyParams = _ref18.bulkCopyParams;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].bulkCopyRagRating({ bulkCopyParams: bulkCopyParams }).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    copyRagRating: function copyRagRating(_ref19, _ref20) {
      var _this5 = this;

      var commit = _ref19.commit,
          dispatch = _ref19.dispatch;
      var sourceVehicleId = _ref20.sourceVehicleId,
          targetVehicleId = _ref20.targetVehicleId;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].copyRagRating({ sourceVehicleId: sourceVehicleId, targetVehicleId: targetVehicleId }).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    audit: function audit(_ref21, data) {
      var _this6 = this;

      var commit = _ref21.commit,
          dispatch = _ref21.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].audit(data).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    setSortDir: function setSortDir(_ref22, sortDir) {
      var commit = _ref22.commit;

      commit('SET_SORT_DIR', sortDir);
    },
    setOrderBy: function setOrderBy(_ref23, orderBy) {
      var commit = _ref23.commit;

      commit('SET_ORDER_BY', orderBy);
    }
  },
  mutations: {
    SET_PAGE_SIZE: function SET_PAGE_SIZE(state, value) {
      if (value !== undefined && value !== null) {
        state.pageSize = parseInt(value);
      }
    },
    SET_LOOKUPS: function SET_LOOKUPS(state, _ref24) {
      var keys = _ref24.keys,
          data = _ref24.data;

      if (data !== undefined && data !== null) {
        if ((typeof keys === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(keys)) === 'object') {
          if (data !== '') {
            keys.forEach(function (x) {
              __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookups, x, data.filter(function (l) {
                return l.key === x;
              }));
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookups, keys, data);
        }
      }
    },
    SET_LOOKUPS_ZEUS: function SET_LOOKUPS_ZEUS(state, _ref25) {
      var key = _ref25.key,
          data = _ref25.data;

      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookupsZeus, key, data);
    },
    SET_SERVICE_ELEMENTS: function SET_SERVICE_ELEMENTS(state, data) {
      state.serviceElements = data;
    },
    SET_SERVICE_ELEMENT_GROUPS: function SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data;
    },
    SET_SERVICE_ELEMENT: function SET_SERVICE_ELEMENT(state, data) {
      var idx = state.serviceElements.findIndex(function (i) {
        return i.id === data.id;
      });
      if (idx !== -1) {
        if (!data.isActive) {
          state.serviceElements.splice(idx, 1);
        } else {
          state.serviceElements[idx].name = data.name;
          state.serviceElements[idx].serviceElementGroupId = data.serviceElementGroupId;
          state.serviceElements[idx].serviceElementGroupName = data.serviceElementGroupName;
          state.serviceElements[idx].isActive = data.isActive;
        }
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName
        };
        state.serviceElements.push(lookup);
      }
    },
    SET_LOOKUP: function SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup);
      } else {
        var index = state.lookups[lookup.key].findIndex(function (i) {
          return i.id === lookup.id;
        });
        state.lookups[lookup.key].splice(index, 1);
      }
    },
    SET_MAKES: function SET_MAKES(state, data) {
      state.makes = data;
    },
    SET_MODELS: function SET_MODELS(state, data) {
      state.models = data;
    },
    SET_COPY_MODELS: function SET_COPY_MODELS(state, data) {
      state.copyModels = data;
    },
    SET_SERVICE_ELEMENTS_RAG_RATING: function SET_SERVICE_ELEMENTS_RAG_RATING(state, data) {
      state.serviceElementsRagRating = data;
    },
    SET_SORT_DIR: function SET_SORT_DIR(state, text) {
      if (text !== undefined && text !== null) {
        state.sortDir = text;
      }
    },
    SET_ORDER_BY: function SET_ORDER_BY(state, text) {
      if (text !== undefined && text !== null) {
        state.orderBy = text;
      }
    },
    SET_VEHICLE_RAG_RATING_ID: function SET_VEHICLE_RAG_RATING_ID(state, data) {
      state.vehicleRagRatingId = data;
    },
    SET_RAG_AUDIT_TYPE_LIST: function SET_RAG_AUDIT_TYPE_LIST(state, data) {
      state.ragAuditTypeList = data;
    },
    SET_RAG_AUDIT_LOG: function SET_RAG_AUDIT_LOG(state, data) {
      state.totalLogEntries = 0;
      state.ragAuditLog = [];
      if (data !== undefined && data !== null) {
        if (data.length > 0) {
          state.totalLogEntries = data[0].TotalItems;
          state.ragAuditLog = data;
        }
      }
    }
  }
};

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "servicerequests", function() { return servicerequests; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(303);





var servicerequests = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "translation", function() { return translation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(307);





var translation = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(312);





var users = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(224);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('business', ['business'])),
  created: function created() {
    this.checkAuth();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('authorize', ['checkAuth']))
});

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(224);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var modules = {};
var files = __webpack_require__(1016);

files.keys().forEach(function (path, i) {
  var module = files(path);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(module).forEach(function (lang) {
    modules[lang] = module[lang];
  });
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({ modules: modules }));

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.4","D:\\a\\1\\s"]],"_development":true,"_from":"elliptic@6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.4","saveSpec":null,"fetchSpec":"6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_spec":"6.5.4","_where":"D:\\a\\1\\s","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 401,
	"./af.js": 401,
	"./ar": 408,
	"./ar-dz": 402,
	"./ar-dz.js": 402,
	"./ar-kw": 403,
	"./ar-kw.js": 403,
	"./ar-ly": 404,
	"./ar-ly.js": 404,
	"./ar-ma": 405,
	"./ar-ma.js": 405,
	"./ar-sa": 406,
	"./ar-sa.js": 406,
	"./ar-tn": 407,
	"./ar-tn.js": 407,
	"./ar.js": 408,
	"./az": 409,
	"./az.js": 409,
	"./be": 410,
	"./be.js": 410,
	"./bg": 411,
	"./bg.js": 411,
	"./bm": 412,
	"./bm.js": 412,
	"./bn": 414,
	"./bn-bd": 413,
	"./bn-bd.js": 413,
	"./bn.js": 414,
	"./bo": 415,
	"./bo.js": 415,
	"./br": 416,
	"./br.js": 416,
	"./bs": 417,
	"./bs.js": 417,
	"./ca": 418,
	"./ca.js": 418,
	"./cs": 419,
	"./cs.js": 419,
	"./cv": 420,
	"./cv.js": 420,
	"./cy": 421,
	"./cy.js": 421,
	"./da": 422,
	"./da.js": 422,
	"./de": 425,
	"./de-at": 423,
	"./de-at.js": 423,
	"./de-ch": 424,
	"./de-ch.js": 424,
	"./de.js": 425,
	"./dv": 426,
	"./dv.js": 426,
	"./el": 427,
	"./el.js": 427,
	"./en-au": 428,
	"./en-au.js": 428,
	"./en-ca": 429,
	"./en-ca.js": 429,
	"./en-gb": 430,
	"./en-gb.js": 430,
	"./en-ie": 431,
	"./en-ie.js": 431,
	"./en-il": 432,
	"./en-il.js": 432,
	"./en-in": 433,
	"./en-in.js": 433,
	"./en-nz": 434,
	"./en-nz.js": 434,
	"./en-sg": 435,
	"./en-sg.js": 435,
	"./eo": 436,
	"./eo.js": 436,
	"./es": 440,
	"./es-do": 437,
	"./es-do.js": 437,
	"./es-mx": 438,
	"./es-mx.js": 438,
	"./es-us": 439,
	"./es-us.js": 439,
	"./es.js": 440,
	"./et": 441,
	"./et.js": 441,
	"./eu": 442,
	"./eu.js": 442,
	"./fa": 443,
	"./fa.js": 443,
	"./fi": 444,
	"./fi.js": 444,
	"./fil": 445,
	"./fil.js": 445,
	"./fo": 446,
	"./fo.js": 446,
	"./fr": 449,
	"./fr-ca": 447,
	"./fr-ca.js": 447,
	"./fr-ch": 448,
	"./fr-ch.js": 448,
	"./fr.js": 449,
	"./fy": 450,
	"./fy.js": 450,
	"./ga": 451,
	"./ga.js": 451,
	"./gd": 452,
	"./gd.js": 452,
	"./gl": 453,
	"./gl.js": 453,
	"./gom-deva": 454,
	"./gom-deva.js": 454,
	"./gom-latn": 455,
	"./gom-latn.js": 455,
	"./gu": 456,
	"./gu.js": 456,
	"./he": 457,
	"./he.js": 457,
	"./hi": 458,
	"./hi.js": 458,
	"./hr": 459,
	"./hr.js": 459,
	"./hu": 460,
	"./hu.js": 460,
	"./hy-am": 461,
	"./hy-am.js": 461,
	"./id": 462,
	"./id.js": 462,
	"./is": 463,
	"./is.js": 463,
	"./it": 465,
	"./it-ch": 464,
	"./it-ch.js": 464,
	"./it.js": 465,
	"./ja": 466,
	"./ja.js": 466,
	"./jv": 467,
	"./jv.js": 467,
	"./ka": 468,
	"./ka.js": 468,
	"./kk": 469,
	"./kk.js": 469,
	"./km": 470,
	"./km.js": 470,
	"./kn": 471,
	"./kn.js": 471,
	"./ko": 472,
	"./ko.js": 472,
	"./ku": 473,
	"./ku.js": 473,
	"./ky": 474,
	"./ky.js": 474,
	"./lb": 475,
	"./lb.js": 475,
	"./lo": 476,
	"./lo.js": 476,
	"./lt": 477,
	"./lt.js": 477,
	"./lv": 478,
	"./lv.js": 478,
	"./me": 479,
	"./me.js": 479,
	"./mi": 480,
	"./mi.js": 480,
	"./mk": 481,
	"./mk.js": 481,
	"./ml": 482,
	"./ml.js": 482,
	"./mn": 483,
	"./mn.js": 483,
	"./mr": 484,
	"./mr.js": 484,
	"./ms": 486,
	"./ms-my": 485,
	"./ms-my.js": 485,
	"./ms.js": 486,
	"./mt": 487,
	"./mt.js": 487,
	"./my": 488,
	"./my.js": 488,
	"./nb": 489,
	"./nb.js": 489,
	"./ne": 490,
	"./ne.js": 490,
	"./nl": 492,
	"./nl-be": 491,
	"./nl-be.js": 491,
	"./nl.js": 492,
	"./nn": 493,
	"./nn.js": 493,
	"./oc-lnc": 494,
	"./oc-lnc.js": 494,
	"./pa-in": 495,
	"./pa-in.js": 495,
	"./pl": 496,
	"./pl.js": 496,
	"./pt": 498,
	"./pt-br": 497,
	"./pt-br.js": 497,
	"./pt.js": 498,
	"./ro": 499,
	"./ro.js": 499,
	"./ru": 500,
	"./ru.js": 500,
	"./sd": 501,
	"./sd.js": 501,
	"./se": 502,
	"./se.js": 502,
	"./si": 503,
	"./si.js": 503,
	"./sk": 504,
	"./sk.js": 504,
	"./sl": 505,
	"./sl.js": 505,
	"./sq": 506,
	"./sq.js": 506,
	"./sr": 508,
	"./sr-cyrl": 507,
	"./sr-cyrl.js": 507,
	"./sr.js": 508,
	"./ss": 509,
	"./ss.js": 509,
	"./sv": 510,
	"./sv.js": 510,
	"./sw": 511,
	"./sw.js": 511,
	"./ta": 512,
	"./ta.js": 512,
	"./te": 513,
	"./te.js": 513,
	"./tet": 514,
	"./tet.js": 514,
	"./tg": 515,
	"./tg.js": 515,
	"./th": 516,
	"./th.js": 516,
	"./tk": 517,
	"./tk.js": 517,
	"./tl-ph": 518,
	"./tl-ph.js": 518,
	"./tlh": 519,
	"./tlh.js": 519,
	"./tr": 520,
	"./tr.js": 520,
	"./tzl": 521,
	"./tzl.js": 521,
	"./tzm": 523,
	"./tzm-latn": 522,
	"./tzm-latn.js": 522,
	"./tzm.js": 523,
	"./ug-cn": 524,
	"./ug-cn.js": 524,
	"./uk": 525,
	"./uk.js": 525,
	"./ur": 526,
	"./ur.js": 526,
	"./uz": 528,
	"./uz-latn": 527,
	"./uz-latn.js": 527,
	"./uz.js": 528,
	"./vi": 529,
	"./vi.js": 529,
	"./x-pseudo": 530,
	"./x-pseudo.js": 530,
	"./yo": 531,
	"./yo.js": 531,
	"./zh-cn": 532,
	"./zh-cn.js": 532,
	"./zh-hk": 533,
	"./zh-hk.js": 533,
	"./zh-mo": 534,
	"./zh-mo.js": 534,
	"./zh-tw": 535,
	"./zh-tw.js": 535
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ })

},[615]);


// WEBPACK FOOTER //
// static/js/app.c97b05cb3cbf29522d2f.js